// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:42:59.446Z
// Property: Leilani Apartment Homes (ID: 5203580319432704)
// Collections: 51 amenities, 27 floorplans (live), 48 photos, 42 POIs, 3 reviews, 12 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5203580319432704",
  "property_external_id": "1021925",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/leilani-apartment-homes/5XrXsY/",
  "property_apartments_url": "https://www.apartments.com/leilani-apartment-homes-seattle-wa/nq961rp",
  "property_google_business_url": "https://www.google.com/maps/place/Leilani/data=!4m2!3m1!1s0x0:0xb08f6fcb20df21f6?sa=X&ved=2ahUKEwiYkJKOyriSAxW9BzQIHRKOFLMQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47677586962",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "leilani-apartment-homes",
  "property_name": "Leilani Apartment Homes",
  "property_website_url": "https://www.leilaniapts.com/",
  "property_domain": "https://www.leilaniapts.com/",
  "property_address": "10215 Greenwood Ave N",
  "property_full_address": "10215 Greenwood Ave N, Seattle, WA 98133",
  "property_address_1": "10215 Greenwood Ave N",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": "98133",
  "property_address_zip": "98133",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Greenwood",
  "property_address_latitude": "47.7030246",
  "property_address_longitude": "-122.3556124",
  "property_email": "leilani@weidner.com",
  "property_phone": "2068879930",
  "property_call_tracking_phone": "206-709-5341",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Leilani Apartment Homes in Seattle, where upscale living meets vibrant community. Indulge in amenities like our serene infinity pool, inviting movie theater, and panoramic rooftop terrace. With stylish floor plans and energy-efficient features, your perfect space awaits. Browse our availability or schedule a tour to find your new home!",
  "property_long_description": "If you're looking for an apartment in Seattle, WA, our three-in-one community might fit your needs perfectly. Our unique community consists of Leilani on Greenwood, Leilani 2, and Leilani at 107, and it's designed to be three different living experiences in one friendly and cohesive community. Our apartments in Seattle's Greenwood neighborhood honor the historic Leilani Lanes. Located in a vibrant area near Carkeek Park, QFC, Lower Woodland Off Leash Dog Area, the Northgate Station and the Northgate Mall.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-03af-7379-af21-277bb780ad42.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with kitchen island and sliding glass doors to patio.",
    "public_id": "019d019d-03af-7379-af21-277bb780ad42",
    "storage_key": "property/5203580319432704/019d019d-03af-7379-af21-277bb780ad42.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "375",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.53333333333333",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://leilaniapts.securecafe.com/onlineleasing/leilani-apartment-homes/floorplans.aspx",
  "property_resident_portal_url": "https://leilaniapts.securecafenet.com/residentservices/leilani-apartment-homes/userlogin",
  "property_apply_now_url": "https://leilaniapts.securecafe.com/onlineleasing/leilani-apartment-homes/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019f425c-1d90-751c-a1ee-37d0e00578ad.webp",
  "property_primary_logo_media": {
    "alt_text": "Leilani Apartment Homes logo",
    "public_id": "019f425c-1d90-751c-a1ee-37d0e00578ad",
    "storage_key": "property/5203580319432704/019f425c-1d90-751c-a1ee-37d0e00578ad.webp",
    "width": 150,
    "height": 131
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d01a0-5cb9-728e-88c9-c444d0869ec3.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a0-5cb9-728e-88c9-c444d0869ec3",
    "storage_key": "property/5203580319432704/019d01a0-5cb9-728e-88c9-c444d0869ec3.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019f425c-76fc-767b-8e8c-b79a7a8a361f.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f425c-76fc-767b-8e8c-b79a7a8a361f",
    "storage_key": "property/5203580319432704/019f425c-76fc-767b-8e8c-b79a7a8a361f.webp",
    "width": 150,
    "height": 131
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019f425c-6a18-715a-916a-adc09476a2b1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Leilani Apartment Homes logo",
    "public_id": "019f425c-6a18-715a-916a-adc09476a2b1",
    "storage_key": "property/5203580319432704/019f425c-6a18-715a-916a-adc09476a2b1.webp",
    "width": 150,
    "height": 131
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#403230",
  "property_secondary_color": "#b33e25",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 880",
  "property_sqft_min": "385",
  "property_sqft_max": "1054",
  "property_price_range": "1287 - 2725",
  "property_price_min": "1385",
  "property_price_max": "2725",
  "property_available_units": 28,
  "property_facebook_url": "https://www.facebook.com/LeilaniApartments/",
  "property_instagram_url": "https://www.instagram.com/liveatleilani/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJF5uU-qQWkFQR9iHfIMtvj7A",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Leilani Apartment Homes",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Leilani Apartment Homes in vibrant Seattle, WA, where modern living meets unparalleled comfort. Choose from spacious studios to two-bedroom layouts, each featuring high-end finishes and floor-to-ceiling windows. Enjoy exceptional amenities, including a rooftop terrace, fitness center, and gameroom—perfect for unwinding or socializing. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Leilani Apartment Homes in vibrant Seattle, WA, where modern living meets comfort. With stylish studio, one-bedroom, and two-bedroom layouts, you’ll find the ideal space to suit your lifestyle. Don’t wait—browse our available apartments today and step into your new home!",
  "property_home_gallery_blurb": "Welcome to Leilani Apartment Homes, where modern living meets nature's beauty. Choose from stylish studio, one, or two-bedroom floor plans adorned with granite countertops and energy-efficient appliances. Enjoy a vibrant community with extensive amenities like a rooftop terrace, fitness center, and inviting picnic areas. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Seattle, Leilani Apartment Homes offers a variety of stylish living spaces, from cozy studios to spacious two-bedroom layouts. Immerse yourself in the vibrant neighborhood, brimming with local favorites and unique attractions. Uncover the charm that awaits just outside your door—your ideal home is waiting!",
  "property_home_reviews_blurb": "Welcome to Leilani Apartment Homes, where quality meets convenience in the heart of Seattle! Our spacious units feature modern amenities and newer construction, ensuring a comfortable living experience. Residents appreciate our accessible location and friendly staff, highlighting Leilani as a “solid deal in the Seattle market.” Join our vibrant community today!",
  "property_neighborhood_blurb": "Nestled in vibrant Seattle, Leilani Apartment Homes puts you steps away from an array of cultural gems, including the iconic Woodland Park Zoo, the stunning Chihuly Garden & Glass, and the thrilling Museum of Pop Culture. Experience city living with the perfect blend of convenience and adventure. Explore your future home today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Leilani Apartment Homes in Seattle, every detail has been designed for your comfort and enjoyment. Dive into the Greenwood Infinity Pool, unwind at the fire pit, or catch a film in our reservable movie theater. Elevate your lifestyle with energy-efficient apartments and a rooftop terrace featuring an outdoor kitchen.",
  "property_applynow_blurb": "At Leilani Apartment Homes in Seattle, indulge in modern elegance with spacious layouts, including studios and two-bedroom options. Unwind at our Greenwood Infinity Pool or enjoy movie nights in the reservable theater. With smart amenities and unique features, your new home awaits—lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Leilani Apartment Homes in vibrant Seattle, WA, find your perfect space with our thoughtfully designed floor plans, including cozy studios, spacious one bedrooms, and airy two bedrooms. Each layout invites comfort and style. Have questions? Our leasing team is ready to assist—reach out today!",
  "property_faqs_blurb": "At Leilani Apartment Homes in vibrant Seattle, WA, you’ll find the perfect space tailored to your lifestyle, from cozy studios to spacious two-bedroom layouts. Curious about our community? Dive into our FAQs page for insightful answers and discover what makes Leilani the ideal place to call home.",
  "property_floorplans_blurb": "At Leilani Apartment Homes in Seattle, WA, comfort meets style in our thoughtfully designed floor plans. Choose from cozy studios, inviting one-bedroom apartments, or spacious two-bedroom layouts. Each home offers a unique ambiance that suits your lifestyle. Browse our available options and find the perfect floor plan today!",
  "property_gallery_blurb": "At Leilani Apartment Homes in Seattle, every moment is a picture-perfect experience. Relax by the Greenwood Infinity Pool, savor movie nights in our reservable theater, or enjoy sunsets from the rooftop terrace. With stylish floor plans and luxurious amenities, your vibrant lifestyle awaits. Picture yourself living here!",
  "property_interactivemap_blurb": "At Leilani Apartment Homes in Seattle, indulge in unparalleled comfort with floor plans ranging from cozy studios to spacious two-bedrooms. Enjoy luxurious amenities like the Greenwood Infinity Pool, reservable movie theater, and stunning rooftop terrace. Our interactive community map makes finding your perfect home an enjoyable journey—start today!",
  "property_pets_blurb": "Nestled in the vibrant heart of Seattle, Leilani Apartment Homes offers a tranquil oasis with modern comforts. Our pet-friendly community embraces your furry companions, allowing you to enjoy the best of urban living while maintaining the warmth of home. Experience a lifestyle where convenience meets community.",
  "property_referafriend_blurb": "At Leilani Apartment Homes in vibrant Seattle, WA, your perfect living space awaits! Choose from stylish studio, one-bedroom, or two-bedroom floor plans designed for comfort and community. Great friends make great neighbors—share the warmth and refer a friend to join our exceptional community today!",
  "property_residentaccess_blurb": "At Leilani Apartment Homes in Seattle, WA, your ideal living space awaits! Choose from stylish one-bedroom, studio, or two-bedroom floor plans. Access your resident portal now for convenient rent payments, maintenance requests, and exclusive community updates—everything you need, right at your fingertips. Your Seattle sanctuary is just a click away!",
  "property_reviews_blurb": "At Leilani Apartment Homes, nestled in vibrant Seattle, residents appreciate the spacious layouts and quality amenities. Many have praised our \"solid deal\" offering, highlighting the newer construction and attentive staff. Enjoy convenience and comfort close to Ballard and Greenlake with easy access to major highways—making Leilani a community worth considering!",
  "property_created_at": "1752256331830",
  "property_scheduletour_blurb": "At Leilani Apartment Homes in vibrant Seattle, WA, find your perfect space among our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans. Each residence blends comfort with style, creating a welcoming home. Curious about life here? See what our residents have to say and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Leilani Apartment Homes in vibrant Seattle, WA! Your interest in our diverse floor plans, including stylish studios and spacious two-bedroom apartments, is appreciated. Our team will connect with you soon to help you find your perfect home. Exciting living awaits just around the corner!",
  "property_virtualtours_blurb": "Welcome to Leilani Apartment Homes in vibrant Seattle, WA, where comfort meets style. Choose from our thoughtfully designed studio, one-bedroom, or two-bedroom floor plans that cater to your lifestyle. Experience the charm of our community—take a virtual tour today and envision your perfect home!",
  "property_copyright": "2025 All Rights Reserved. Leilani Apartment Homes",
  "property_seo_title_home": "Leilani Apartments | Apartments in Seattle | Weidner",
  "property_seo_description_home": "Come see our beautiful Seattle apartments and make Leilani Apartments your new home.",
  "property_seo_title_floorplans": "Leilani Apartments | Floor Plans | Apartments in Seattle | Weidner",
  "property_seo_description_floorplans": "We have a variety of floorplans here at Leilani Apartments so you can find exactly what you're looking for in an apartment in Seattle.",
  "property_seo_title_amenities": "Leilani Apartments | Amenities | Apartments in Seattle | Weidner",
  "property_seo_description_amenities": "Come see our beautiful apartments in Seattle! Schedule a tour, see photos, and apply now to your new home at Leilani Apartments.",
  "property_seo_title_gallery": "Photo Gallery | Leilani Apartments in Seattle, WA | Weidner",
  "property_seo_description_gallery": "See our gallery of photos of Leilani Apartments and see our community grounds, apartment amenities, and furnishings! Schedule a tour today!",
  "property_seo_title_virtualtours": "Leilani Apartment Homes | Virtual Tour",
  "property_seo_description_virtualtours": "Learn more about Leilani Apartment Homes in Seattle, WA and take a virtual tour.",
  "property_seo_title_interactivemap": "Interactive Map | Leilani Apartment Homes Apartments",
  "property_seo_description_interactivemap": "\"Unlock your ideal lifestyle at Leilani Apartment Homes in Seattle, WA. Our diverse floor plans include studios, one and two-bedroom apartments designed with upgraded appliances, large kitchens, and floor-to-ceiling windows. Enjoy resort-style amenities like the Greenwood Infinity Pool, a reservable movie theater, and a rooftop terrace with an outdoor kitchen. With a convenient online payment system and a strategic location near the D-Line Rapid Ride, your next adventure is just outside your door. Use our interactive community map to find your perfect home today!\"",
  "property_seo_title_neighborhood": "Map and Directions | Leilani Apartment Homes in Seattle, WA | Weidner",
  "property_seo_description_neighborhood": "See a map of the general Seattle area and find directions to Leilani Apartments to see our community today! View shops, eats, and things to do!",
  "property_seo_title_contact": "Leilani Apartments | Contact Us | Apartments in Seattle | Weidner",
  "property_seo_description_contact": "Get in touch with your Leilani Apartments team for any questions you may have, or to schedule a tour to visit us.",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Uncover the answers to your queries at Leilani Apartment Homes in vibrant Seattle, WA! Our FAQs delve into our diverse floor plans, from studios to two-bedroom layouts, and highlight exceptional amenities like the Greenwood Infinity Pool, reservable movie theater, and inviting rooftop terrace. With convenient online payments and energy-efficient features, discover how our community embodies modern living with a touch of Seattle nostalgia. Curious about life at Leilani? Browse our FAQs page and find everything you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "\"Experience the vibrant lifestyle at Leilani Apartment Homes in Seattle, WA, where luxury meets comfort. Dive into our stunning Greenwood Infinity Pool, catch a flick in the reservable movie theater, or unwind around the fire pit. With modern floor plans ranging from studios to two bedrooms, you're bound to find your perfect fit. Residents rave about our rooftop terrace, exclusive lounges, and convenient amenities like controlled access parking and onsite Amazon lockers. Join our community and see why living at Leilani feels like home! Check out what our residents have to say!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "\"Experience the vibrant lifestyle at Leilani Apartment Homes in Seattle, WA, where luxury meets comfort. Choose from stylish floor plans—including studios, one-, and two-bedroom options—featuring large kitchens, floor-to-ceiling windows, and upgraded appliances. Enjoy resort-style amenities like the Greenwood Infinity Pool, a reservable movie theater, and a tranquil outdoor pavilion. With a rooftop terrace and controlled access parking, your perfect home awaits. Ready to elevate your living? Lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Leilani Apartment Homes",
  "property_seo_description_residentaccess": "Unlock convenience at Leilani Apartment Homes in Seattle, WA. Access your resident portal effortlessly to manage your rent, schedule maintenance, and enjoy exclusive community features. Seamless living awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Leilani Apartment Homes",
  "property_seo_description_referafriend": "\"At Leilani Apartment Homes in Seattle, we believe great friends make the best neighbors! Refer a friend and unlock exclusive perks while enjoying a vibrant community. Share the love of your home today!\"",
  "property_seo_title_scheduletour": "Schedule A Tour | Leilani Apartments in Seattle, WA | Weidner",
  "property_seo_description_scheduletour": "Schedule a tour to see our available studio, one, and two bed apartments for rent at Leilani Apartment Homes in Seattle, WA today!",
  "property_seo_title_privacy": "Privacy Policy | Leilani Apartment Homes",
  "property_seo_description_privacy": "Our privacy policy outlines how we protect your personal information while you enjoy the best living experience in the heart of the city.",
  "property_seo_title_accessibility": "Website Accessibility | Leilani Apartment Homes",
  "property_seo_description_accessibility": "Our commitment to digital inclusion ensures that everyone can enjoy a seamless online experience while exploring our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Leilani Apartment Homes",
  "property_seo_description_sitemap": "Navigate your future at Leilani Apartment Homes in Seattle, WA. Our sitemap makes it easy to explore our vibrant community, spacious floor plans, and more.",
  "property_seo_title_thankyou": "Thank You | Leilani Apartment Homes",
  "property_seo_description_thankyou": "Thank you for your interest in Leilani Apartment Homes! Your inquiry is in good hands, and our dedicated team will reach out shortly to assist you.",
  "property_seo_title_pets": "Pet Policy | Leilani Apartment Homes in Seattle, WA | Weidner",
  "property_seo_description_pets": "Leilani Apartment Homes is more than just pet-friendly—we LOVE pets! Enjoy treats in the office, Pet of the Month spotlights, and fun Yappy Hours!",
  "property_updated_at": "1793119460482",
  "amenities": [
    {
      "id": "ec_8b99629fa3428860c40c3aa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902796",
      "title": "BBQ Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d48573500914c7be18c662d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902797",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_022372a33e2d27fd92dd9290",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902823",
      "title": "Built-in microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ead32fcac66185dc011c30d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902829",
      "title": "Washer & dryer in every home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_455607dc23f74c6fb83400aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902830",
      "title": "Linen closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed3e8a162e2c8ed7f918acbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902831",
      "title": "Patios or Juliette balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c0dde2a1687bf7026fb4078",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902808",
      "title": "Greenwood Infinity Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-f5f7-73d8-a252-af77f99c8010.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d019d-f5f7-73d8-a252-af77f99c8010",
        "storage_key": "property/5203580319432704/019d019d-f5f7-73d8-a252-af77f99c8010.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ef8ac4a5d22b63751cb1aa0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902824",
      "title": "Dual Color Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f0209303fd56e2f02c1b18d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902795",
      "title": "Greenwood Reservable Movie Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-f677-7788-8a87-250681258f28.webp",
      "amenity_image_media": {
        "alt_text": "Entertainment lounge with bar seating and a large television.",
        "public_id": "019d019d-f677-7788-8a87-250681258f28",
        "storage_key": "property/5203580319432704/019d019d-f677-7788-8a87-250681258f28.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c133fcca62a4a760768eab7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902825",
      "title": "Energy efficient heating with individually controlled thermostats",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a1d9ebac4b2157556b38e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902817",
      "title": "Greenwood Trellised Outdoor Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-81a8-7589-80a8-46989e11fa53.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
        "public_id": "019d019d-81a8-7589-80a8-46989e11fa53",
        "storage_key": "property/5203580319432704/019d019d-81a8-7589-80a8-46989e11fa53.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d409e07715bad0d800b8ca2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902827",
      "title": "Floor-to-ceiling windows*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d984958d5852e787a898716",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902804",
      "title": "Greenwood Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-8d94-76cf-bd2b-f8ef9cab66ec.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio with seating, fire pit, and grills.",
        "public_id": "019d019d-8d94-76cf-bd2b-f8ef9cab66ec",
        "storage_key": "property/5203580319432704/019d019d-8d94-76cf-bd2b-f8ef9cab66ec.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_260ac2b4efc1a498e6062722",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902809",
      "title": "Greenwood Wi-Fi Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-fa72-7249-aaf4-1a92d24f36fd.webp",
      "amenity_image_media": {
        "alt_text": "Modern lounge area with a large black table, colorful sofas, and abstract art.",
        "public_id": "019d019d-fa72-7249-aaf4-1a92d24f36fd",
        "storage_key": "property/5203580319432704/019d019d-fa72-7249-aaf4-1a92d24f36fd.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82ed6da679ca0d2d577f5edf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902810",
      "title": "Greenwood Reservable Resident Lounge and Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-58ff-719f-8e7e-c261812f598e.webp",
      "amenity_image_media": {
        "alt_text": "Billiard table in resident lounge with pool view",
        "public_id": "019d019d-58ff-719f-8e7e-c261812f598e",
        "storage_key": "property/5203580319432704/019d019d-58ff-719f-8e7e-c261812f598e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8cac32f9a83913425afb5d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902801",
      "title": "Three Controlled Access Parking Garages",
      "amount": "false",
      "description": "$115/month",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_586fafc7fdaf5e10fe8269e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902834",
      "title": "Upgraded appliances and fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_577f855c72e8a4f7384f1002",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902793",
      "title": "Greenwood Amazon Locker System",
      "amount": "false",
      "description": "Don't wait for the office to open! Pick-up packages when it is convenient with our exclusive resident Amazon Locker System.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bef7c2af236b7d1cafb73260",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902835",
      "title": "USB charging outlets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_915fc1517fda72e98390954c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902819",
      "title": "Greenwood Outdoor Path & Rain Garden",
      "amount": "false",
      "description": "Great for dogs!",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d75a5837f5a0d03bbb282ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902836",
      "title": "Water efficient fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8367e02d853b098b0466b5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "87367872",
      "title": "Large kitchen*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a55b9f95483df1d60ccfd1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "87367873",
      "title": "Large closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c86fddf63d0f8713926fb5b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902794",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Accepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a643c0b500c02ba21db0c45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "87367870",
      "title": "Leilani 2 stainless steel appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_effc1018b7e6ff671028b0a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "87367871",
      "title": "Leilani 2 granite countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afd88d9b698f5a29f35b182a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768207",
      "title": "Floor Level 2",
      "amount": "false",
      "description": "Floor Level 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0acddb475addae2d7001d7a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902803",
      "title": "Entry Water Feature Honoring the Nostalgia of Seattle's Leilani Lanes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e733831106f15abefb5be1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768209",
      "title": "Floor Level 3",
      "amount": "false",
      "description": "Floor Level 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9017f6e757f94b9b39105f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "121411315",
      "title": "Optional Access to Greenwood Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67586fd236cb0f4336b83688",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768210",
      "title": "Floor Level 4",
      "amount": "false",
      "description": "Floor Level 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f51c0a992f50819c898e846e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "124799686",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f7ab771f2547ca63add5032",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768212",
      "title": "Floor Level 4-ADA",
      "amount": "false",
      "description": "Floor Level 4-ADA",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5338c8b5f006cc7821c6624",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902812",
      "title": "107 Rooftop Terrace with Outdoor Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9e9334ab6617aea68852a1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "128984192",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66ff45c8cab2da8206c2bb95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768213",
      "title": "Floor Level 5",
      "amount": "false",
      "description": "Floor Level 5",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_003cce89b3937a41818ff2d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "86902813",
      "title": "Short Distance to D-Line Rapid Ride",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b9e04ebce55700e19a76d09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768214",
      "title": "Large Patio",
      "amount": "false",
      "description": "Large Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0602a1f7bf1fdf6cf71ef02e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768215",
      "title": "Location 1",
      "amount": "false",
      "description": "Location 1",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1193c3b12829821f30b5f75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768216",
      "title": "Location 2",
      "amount": "false",
      "description": "Location 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43064a376f8f1a36e05c3974",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768217",
      "title": "Open Kitchen",
      "amount": "false",
      "description": "Open Kitchen",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d88f62868098e42d41597b57",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768218",
      "title": "Patio",
      "amount": "false",
      "description": "Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b59cd6c2426d5ed25c3d9d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768219",
      "title": "Prime Location",
      "amount": "false",
      "description": "Prime Location",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64b03e58911098872039713c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768220",
      "title": "Upgraded Finishes",
      "amount": "false",
      "description": "Upgraded Finishes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44b7f8f69ebdbf65e6bc2886",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768221",
      "title": "View Courtyard",
      "amount": "false",
      "description": "View Courtyard",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57f370f892425037a6eff380",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768227",
      "title": "Prime View",
      "amount": "false",
      "description": "Prime View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_798f12776ab845d7e74daf78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768229",
      "title": "Skyline View",
      "amount": "false",
      "description": "Skyline View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa9b619d4cdb689d88d4de81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768231",
      "title": "Vinyl Throughout",
      "amount": "false",
      "description": "Vinyl Throughout",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ffd11774a16a953ca3d1843",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768232",
      "title": "Wall of Windows",
      "amount": "false",
      "description": "Wall of Windows",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdcf6a4b000448737d1c4ae2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768233",
      "title": "Washer/Dryer Full-Size",
      "amount": "false",
      "description": "Washer/Dryer Full-Size",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57d31f784a562fdfdd0a3c4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "126768234",
      "title": "XL Patio",
      "amount": "false",
      "description": "XL Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_2a18ade2b366a991f517950e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-03af-7379-af21-277bb780ad42.webp",
      "image_media": {
        "alt_text": "Modern living room with kitchen island and sliding glass doors to patio.",
        "public_id": "019d019d-03af-7379-af21-277bb780ad42",
        "storage_key": "property/5203580319432704/019d019d-03af-7379-af21-277bb780ad42.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and modern living area with a fully equipped kitchen, comfortable seating, and abundant natural light. Step out onto your private patio.",
      "link": "false",
      "alt_text": "A stylish open living room here at Leilani on Greenwood featuring light wood-style flooring, a modern seating area with a sofa and lounge chair, and a sleek coffee table atop an area rug. The space opens to a contemporary kitchen with bar seating, while sliding glass doors bring in natural light and connect to an outdoor patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(1).jpg"
    },
    {
      "id": "ec_fb0871b636c1e9ba5782beb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-0379-74ee-aa6d-63c14ee34a0e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a breakfast bar and two stools.",
        "public_id": "019d019d-0379-74ee-aa6d-63c14ee34a0e",
        "storage_key": "property/5203580319432704/019d019d-0379-74ee-aa6d-63c14ee34a0e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living and kitchen area featuring a breakfast bar with stools, perfect for casual dining and entertaining.",
      "link": "false",
      "alt_text": "A modern open living area here at Leilani on Greenwood featuring light wood-style flooring, a cozy seating area, and contemporary artwork on neutral walls. A breakfast bar with barstool seating connects to the kitchen, while an open closet area and entry hallway add functionality to the thoughtfully designed layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(2).jpg"
    },
    {
      "id": "ec_2364e94cd9b44d0b87eba10b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-0337-7038-90a4-a4e82531e14f.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, wooden cabinets, and granite countertops.",
        "public_id": "019d019d-0337-7038-90a4-a4e82531e14f",
        "storage_key": "property/5203580319432704/019d019d-0337-7038-90a4-a4e82531e14f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample storage with wooden cabinets, and sleek granite countertops.",
      "link": "false",
      "alt_text": "A sleek kitchen here at Leilani on Greenwood featuring flat-panel wood cabinetry, smooth countertops, and a stainless steel sink set beneath under-cabinet lighting. Dark appliances line the workspace, while light wood-style flooring and modern fixtures create a clean, contemporary cooking area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(3).jpg"
    },
    {
      "id": "ec_6e0fab1cf53d26c7ee6bea1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-032f-7657-a5c6-decfd70924e8.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances and elegant decor.",
        "public_id": "019d019d-032f-7657-a5c6-decfd70924e8",
        "storage_key": "property/5203580319432704/019d019d-032f-7657-a5c6-decfd70924e8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen and dining space, perfect for preparing meals and enjoying intimate dinners. Features modern appliances and stylish finishes.",
      "link": "false",
      "alt_text": "A contemporary kitchen and dining area here at Leilani on Greenwood featuring flat-panel wood cabinetry, dark lower cabinets, smooth countertops, and a stainless steel sink and appliances. A peninsula counter opens to a dining table, while track lighting and light wood-style flooring create a clean, modern layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(4).jpg"
    },
    {
      "id": "ec_6060a02038542c7daa1fd2da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-0f90-74ff-ae69-6cfd0fe00dce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space.",
        "public_id": "019d019d-0f90-74ff-ae69-6cfd0fe00dce",
        "storage_key": "property/5203580319432704/019d019d-0f90-74ff-ae69-6cfd0fe00dce.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Explore the sleek, modern kitchen at Leilani on Greenwood, featuring stainless steel appliances and elegant cabinetry for a functional and stylish living experience.",
      "link": "false",
      "alt_text": "A modern galley-style kitchen here at Leilani on Greenwood featuring flat-panel wood cabinetry, smooth countertops, and a stainless steel sink with a dishwasher below. Dark appliances line the cooking area, while pendant and track lighting, light wood-style flooring, and a breakfast bar create a bright and functional space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(5).jpg"
    },
    {
      "id": "ec_3455e8ee18d73e5787448242",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-0eee-73bf-b103-27675073ee18.webp",
      "image_media": {
        "alt_text": "Bedroom at Leilani on Greenwood with a queen bed, nightstand, lamp, and abstract art.",
        "public_id": "019d019d-0eee-73bf-b103-27675073ee18",
        "storage_key": "property/5203580319432704/019d019d-0eee-73bf-b103-27675073ee18.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in the master bedroom at Leilani on Greenwood, featuring a comfortable queen-sized bed, elegant nightstand with lamp, and tasteful abstract artwork. ",
      "link": "false",
      "alt_text": "A cozy bedroom here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and a bed with patterned bedding and accent pillows. A nightstand with a table lamp, framed artwork above the headboard, and overhead lighting create a warm, comfortable space designed for rest and relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(6).jpg"
    },
    {
      "id": "ec_1f599e7d0d9f97e9e1c6c8c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-10ae-7729-a7ed-d0f4b5ac3474.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a yellow curtain.",
        "public_id": "019d019d-10ae-7729-a7ed-d0f4b5ac3474",
        "storage_key": "property/5203580319432704/019d019d-10ae-7729-a7ed-d0f4b5ac3474.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in style in this elegant bathroom featuring a spacious vanity, modern fixtures, and a beautifully designed shower.",
      "link": "false",
      "alt_text": "A convenient in-home laundry area here at Leilani on Greenwood featuring a stacked washer and dryer neatly tucked inside a dedicated closet. Wood-look doors provide a clean finish, while the compact layout offers easy access to laundry without leaving the apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(7).jpg"
    },
    {
      "id": "ec_8775964f27095257026ccdcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-10f9-70df-be0c-d6f907e8f4bb.webp",
      "image_media": {
        "alt_text": "Stacked white washer and dryer unit.",
        "public_id": "019d019d-10f9-70df-be0c-d6f907e8f4bb",
        "storage_key": "property/5203580319432704/019d019d-10f9-70df-be0c-d6f907e8f4bb.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "In-unit stacked washer and dryer for your laundry convenience.",
      "link": "false",
      "alt_text": "A modern kitchen here at Leilani on Greenwood featuring gray wood-style cabinetry, a light stone countertop, and a central island with an integrated sink and bar seating. Stainless steel appliances line the cooking area, while open shelving, wood-style flooring, and overhead lighting create a clean, contemporary space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(8).jpg"
    },
    {
      "id": "ec_106ce95a6b88acf323d3a409",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-1a34-726c-84f5-243f893455c9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019d019d-1a34-726c-84f5-243f893455c9",
        "storage_key": "property/5203580319432704/019d019d-1a34-726c-84f5-243f893455c9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this beautifully appointed kitchen, featuring sleek cabinetry, granite countertops, and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "A modern kitchen here at Leilani on Greenwood featuring gray wood-style cabinetry, a light stone countertop, and a central island with an integrated sink and bar seating. Stainless steel appliances line the cooking area, while open shelving, wood-style flooring, and overhead lighting create a clean, contemporary space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(9).jpg"
    },
    {
      "id": "ec_efbaa77f76b566591cb40616",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-1b5e-7119-8058-3da066e6d00a.webp",
      "image_media": {
        "alt_text": "Kitchen area with granite countertops, stainless steel refrigerator, and gas range.",
        "public_id": "019d019d-1b5e-7119-8058-3da066e6d00a",
        "storage_key": "property/5203580319432704/019d019d-1b5e-7119-8058-3da066e6d00a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, stainless steel appliances, and a breakfast bar with a stool.",
      "link": "false",
      "alt_text": "A modern kitchen here at Leilani on Greenwood featuring gray wood-style cabinetry, a light stone countertop, and a wide breakfast bar with seating. Stainless steel appliances and an integrated sink face the open living area, while soft overhead lighting and neutral finishes create a clean, functional layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(10).jpg"
    },
    {
      "id": "ec_cef15d22ec0e5367b772e1f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-1bca-7298-a5f7-d7f96392c2d0.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, granite countertops, and a sink.",
        "public_id": "019d019d-1bca-7298-a5f7-d7f96392c2d0",
        "storage_key": "property/5203580319432704/019d019d-1bca-7298-a5f7-d7f96392c2d0.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "A modern kitchen here at Leilani on Greenwood featuring gray wood-style cabinetry, a light stone countertop, and an undermount sink with a tall gooseneck faucet. A refrigerator and dishwasher sit nearby, while wood-style flooring and soft overhead lighting complete the clean, functional cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(11).jpg"
    },
    {
      "id": "ec_74390df77ec59b8ba427bc10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-1dcb-77a2-ab7e-08bce33cd6f1.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops and stainless steel sink, open to a carpeted living area with blinds.",
        "public_id": "019d019d-1dcb-77a2-ab7e-08bce33cd6f1",
        "storage_key": "property/5203580319432704/019d019d-1dcb-77a2-ab7e-08bce33cd6f1.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment featuring a modern kitchen with granite countertops and a deep sink, flowing seamlessly into a spacious, carpeted living area perfect for relaxation.",
      "link": "false",
      "alt_text": "A spacious open living area here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and a large window with blinds that brings in natural light. The space connects to a modern kitchen with a light stone countertop, undermount sink, and wood-style cabinetry, creating a comfortable and functional open-concept layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(12).jpg"
    },
    {
      "id": "ec_510cb4123a4229cac0aaa590",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-248f-71b2-a92b-a5ec33a4d221.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and a large window overlooking trees.",
        "public_id": "019d019d-248f-71b2-a92b-a5ec33a4d221",
        "storage_key": "property/5203580319432704/019d019d-248f-71b2-a92b-a5ec33a4d221.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed and a spacious window that offers a serene view of the surrounding greenery.",
      "link": "false",
      "alt_text": "A bright bedroom here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and a bed with layered gray and white bedding. A large window with blinds fills the room with natural light and offers leafy neighborhood views, while the open layout provides comfortable space for bedroom furnishings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(13).jpg"
    },
    {
      "id": "ec_14acb12aecdf6cb6ce0fbe6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-25b4-71f8-ba65-41826d2f2334.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, faucet, and mirror reflection of bedroom.",
        "public_id": "019d019d-25b4-71f8-ba65-41826d2f2334",
        "storage_key": "property/5203580319432704/019d019d-25b4-71f8-ba65-41826d2f2334.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite countertop, undermount sink, and a spacious vanity mirror. The reflection shows a glimpse of the bedroom.",
      "link": "false",
      "alt_text": "A clean bathroom here at Leilani on Greenwood featuring a light stone countertop with an integrated sink, a wood vanity with storage below, and a wide wall mirror with overhead lighting. Neutral walls, coordinating fixtures, and a nearby doorway create a bright, functional layout connected to the bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(14).jpg"
    },
    {
      "id": "ec_419668759590695b8957f461",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-2808-70b2-b6fe-37f99fadc6c4.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and sink, toilet, and bathtub with shower.",
        "public_id": "019d019d-2808-70b2-b6fe-37f99fadc6c4",
        "storage_key": "property/5203580319432704/019d019d-2808-70b2-b6fe-37f99fadc6c4.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite-top vanity with a spacious sink, a convenient toilet, and a relaxing bathtub with a showerhead.",
      "link": "false",
      "alt_text": "A well-appointed bathroom here at Leilani on Greenwood featuring a wood vanity with a light stone countertop, an integrated sink, and wide wall mirrors with overhead lighting. A toilet sits beside the vanity, while a bathtub-shower combo with a curtain completes the clean, functional layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(15).jpg"
    },
    {
      "id": "ec_0a0cf8d848279deeb2f22e02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-2914-72ff-8d5e-e32a040a1f15.webp",
      "image_media": {
        "alt_text": "Bathroom with a white bathtub, toilet, and shower curtain.",
        "public_id": "019d019d-2914-72ff-8d5e-e32a040a1f15",
        "storage_key": "property/5203580319432704/019d019d-2914-72ff-8d5e-e32a040a1f15.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a bathtub, toilet, and a decorative shower curtain, perfect for relaxing after a long day.",
      "link": "false",
      "alt_text": "A simple bathroom here at Leilani on Greenwood featuring a bathtub-shower combo with a curtain, a toilet positioned beside a light stone countertop, and neutral wall finishes. A towel bar with folded towels and clean lines create a practical, easy-to-use space within the apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(16).jpg"
    },
    {
      "id": "ec_993a24189d9ea899175cd4ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-308d-7479-b2f1-df35798ab8dc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d019d-308d-7479-b2f1-df35798ab8dc",
        "storage_key": "property/5203580319432704/019d019d-308d-7479-b2f1-df35798ab8dc.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Explore the beautifully appointed kitchen in our apartments, featuring sleek cabinetry, granite countertops, and stainless steel appliances for a sophisticated cooking experience.",
      "link": "false",
      "alt_text": "A modern kitchen here at Leilani on Greenwood featuring gray wood-style cabinetry, light stone countertops, and a full cooking area with a range, hood, and refrigerator. Upper and lower cabinets provide storage, while clean finishes, simple décor, and overhead lighting create a functional and contemporary kitchen layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(17).jpg"
    },
    {
      "id": "ec_7f24804d3ab885d1bdff58bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-34cc-7398-9e51-70345d9ade78.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors leading to a balcony, sofa, coffee table, and accent chairs.",
        "public_id": "019d019d-34cc-7398-9e51-70345d9ade78",
        "storage_key": "property/5203580319432704/019d019d-34cc-7398-9e51-70345d9ade78.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living room with comfortable seating, a modern coffee table, and a sliding glass door offering access to a private balcony with a scenic view.",
      "link": "false",
      "alt_text": "A spacious open living area here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and an open layout that connects to the kitchen. A breakfast bar with a light stone countertop overlooks the living space, while overhead lighting and a hallway entry create a clean, functional apartment layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(18).jpg"
    },
    {
      "id": "ec_efdbf9e49eb18b90f978aed3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-34fa-7200-8dd3-6970b9cd85f1.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with breakfast bar",
        "public_id": "019d019d-34fa-7200-8dd3-6970b9cd85f1",
        "storage_key": "property/5203580319432704/019d019d-34fa-7200-8dd3-6970b9cd85f1.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen with a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "A spacious open living area here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and an open layout that connects to the kitchen. A breakfast bar with a light stone countertop overlooks the living space, while overhead lighting and a hallway entry create a clean, functional apartment layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(19).jpg"
    },
    {
      "id": "ec_d65726e3a39d26ef0ed84059",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-3d65-703b-a19f-77c77b1d1834.webp",
      "image_media": {
        "alt_text": "Bedroom with two closets and a large window",
        "public_id": "019d019d-3d65-703b-a19f-77c77b1d1834",
        "storage_key": "property/5203580319432704/019d019d-3d65-703b-a19f-77c77b1d1834.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, ample closet space, and a large window with blinds for natural light. Perfect for a comfortable living space.",
      "link": "false",
      "alt_text": "A spacious bedroom here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and a large window with blinds that brings in natural light. Two open closets with hanging rods provide ample storage, while overhead lighting and a simple layout create a bright, comfortable sleeping space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(20).jpg"
    },
    {
      "id": "ec_d33e3f009ae31153bed54e4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-3ecb-740f-a4a3-239db6098314.webp",
      "image_media": {
        "alt_text": "Living room with large sliding glass doors and balcony access, view of kitchen counter.",
        "public_id": "019d019d-3ecb-740f-a4a3-239db6098314",
        "storage_key": "property/5203580319432704/019d019d-3ecb-740f-a4a3-239db6098314.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living area featuring large sliding glass doors that open to a balcony, with a glimpse of the modern kitchen counter.",
      "link": "false",
      "alt_text": "A sunlit open living area here at Leilani on Greenwood featuring soft carpeted flooring, neutral walls, and large sliding glass doors with vertical blinds that open to a private balcony. Natural light fills the space, which flows toward the kitchen area with a breakfast bar, creating an airy and inviting layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(21).jpg"
    },
    {
      "id": "ec_cc427f7c36d6b2890eb1a8bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-4000-7791-864a-101181d9afb3.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and hallway view.",
        "public_id": "019d019d-4000-7791-864a-101181d9afb3",
        "storage_key": "property/5203580319432704/019d019d-4000-7791-864a-101181d9afb3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a spacious closet and access to a hallway with a front door, offering comfort and convenience.",
      "link": "false",
      "alt_text": "A clean bathroom here at Leilani on Greenwood featuring a long vanity with warm wood cabinetry, a smooth countertop with an integrated sink, and a large wall mirror with overhead lighting. The space includes a toilet, towel bars, and a tub with a shower, creating a simple and functional layout with neutral finishes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(22).jpg"
    },
    {
      "id": "ec_c8ef7c27fba7733b994f181a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-40f1-71cf-be88-751e82852ff9.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, wooden cabinets, and stacked washer and dryer visible in mirror.",
        "public_id": "019d019d-40f1-71cf-be88-751e82852ff9",
        "storage_key": "property/5203580319432704/019d019d-40f1-71cf-be88-751e82852ff9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage, a clean sink, and convenient in-unit laundry.",
      "link": "false",
      "alt_text": "A modern bathroom here at Leilani on Greenwood featuring a spacious vanity with warm wood cabinetry, a smooth countertop with an integrated sink, and a large wall mirror beneath bright overhead lighting. The layout includes a toilet and a visible in-home laundry area reflected in the mirror, creating a functional and efficient space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(23).jpg"
    },
    {
      "id": "ec_6fcf0f28cc7f1d6602e3e6b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-4789-72ca-8807-632a120547cd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wood vanity, white sink, and white tiled shower/tub combo.",
        "public_id": "019d019d-4789-72ca-8807-632a120547cd",
        "storage_key": "property/5203580319432704/019d019d-4789-72ca-8807-632a120547cd.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a sleek wood vanity with a white undermount sink, complemented by a white tiled shower and tub combination for a spa-like feel.",
      "link": "false",
      "alt_text": "A clean bathroom here at Leilani on Greenwood featuring a long vanity with warm wood cabinetry, a smooth countertop with an integrated sink, and a large wall mirror with overhead lighting. The space includes a toilet, towel bars, and a tub with a shower, creating a simple and functional layout with neutral finishes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(24).jpg"
    },
    {
      "id": "ec_34aefa7971fd46a4e66bb0a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-48c3-717e-9e6b-9b081e258b40.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer next to a bathroom vanity with sink and toilet.",
        "public_id": "019d019d-48c3-717e-9e6b-9b081e258b40",
        "storage_key": "property/5203580319432704/019d019d-48c3-717e-9e6b-9b081e258b40.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a stackable washer and dryer, adjacent to a modern bathroom featuring a vanity, sink, and toilet.",
      "link": "false",
      "alt_text": "A convenient laundry nook here at Leilani on Greenwood featuring a stacked washer and dryer tucked inside a dedicated closet, positioned just off a bathroom with a long vanity, warm wood cabinetry, a smooth countertop with an integrated sink, and overhead lighting, creating a functional and efficient in-home layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(25).jpg"
    },
    {
      "id": "ec_9da3b0a0cac2df3d61fb195e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-4ce4-72d0-b262-e7bd2e7954b7.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and living area with stainless steel appliances and wood flooring.",
        "public_id": "019d019d-4ce4-72d0-b262-e7bd2e7954b7",
        "storage_key": "property/5203580319432704/019d019d-4ce4-72d0-b262-e7bd2e7954b7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a modern kitchen with stainless steel appliances and ample cabinet space, adjacent to a bright living area with large windows and wood floors.",
      "link": "false",
      "alt_text": "A spacious open living area here at Leilani on Greenwood featuring wood-style flooring, a wide wall of space for flexible furniture placement, and a modern kitchen with warm wood cabinetry, a full appliance suite, sleek countertops, and track lighting that brightens the open-concept layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(26).jpg"
    },
    {
      "id": "ec_35b92ccfa37ebf09540f1f96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-52bb-7193-82d1-aa84594d18ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets, adjacent to a living area with large windows.",
        "public_id": "019d019d-52bb-7193-82d1-aa84594d18ce",
        "storage_key": "property/5203580319432704/019d019d-52bb-7193-82d1-aa84594d18ce.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a modern kitchen with sleek cabinetry and stainless steel appliances, complemented by a bright living area with ample natural light.",
      "link": "false",
      "alt_text": "A sunlit open-concept living area here at Leilani on Greenwood featuring wood-style flooring, a modern kitchen with warm wood cabinetry, a full appliance suite, and track lighting, with large sliding glass doors that open to a private balcony and allow natural light to fill the spacious layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(27).jpg"
    },
    {
      "id": "ec_1ee26b9463c20a38a59a5fa6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-541a-708b-a7c2-44acf55a8160.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer next to a bathroom with vanity.",
        "public_id": "019d019d-541a-708b-a7c2-44acf55a8160",
        "storage_key": "property/5203580319432704/019d019d-541a-708b-a7c2-44acf55a8160.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a stacked washer and dryer, adjacent to a stylish bathroom vanity.",
      "link": "false",
      "alt_text": "A bright interior hallway here at Leilani on Greenwood featuring wood-style flooring, neutral walls, and ceiling lighting, with an in-home stacked washer and dryer tucked into a dedicated closet and an adjacent bathroom entry showcasing warm wood cabinetry and a clean, functional layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(28).jpg"
    },
    {
      "id": "ec_99c650c33b46fc661ac4efee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-5818-763f-88bc-2b6e9bdf4730.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019d019d-5818-763f-88bc-2b6e9bdf4730",
        "storage_key": "property/5203580319432704/019d019d-5818-763f-88bc-2b6e9bdf4730.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "A spacious fitness center here at Leilani on Greenwood featuring a variety of cardio machines, strength training equipment, and free weights arranged throughout an open, well-lit room with neutral flooring and ceiling lights, creating a convenient on-site workout space for residents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(29).jpg"
    },
    {
      "id": "ec_325beaf9ecb8115bc52e06f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-58ff-719f-8e7e-c261812f598e.webp",
      "image_media": {
        "alt_text": "Billiard table in resident lounge with pool view",
        "public_id": "019d019d-58ff-719f-8e7e-c261812f598e",
        "storage_key": "property/5203580319432704/019d019d-58ff-719f-8e7e-c261812f598e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in the resident lounge, featuring a pool table and comfortable seating with views of the outdoor swimming pool.",
      "link": "false",
      "alt_text": "A modern resident lounge here at Leilani on Greenwood featuring a billiards table centered beneath contemporary pendant lighting, with large windows providing natural light, adjacent seating and dining areas, and a comfortable open layout designed for socializing and relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(30).jpg"
    },
    {
      "id": "ec_d3d476906775b43fce9742f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-6245-732c-8881-7ac6724e7fe3.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table and seating area, overlooking an outdoor swimming pool.",
        "public_id": "019d019d-6245-732c-8881-7ac6724e7fe3",
        "storage_key": "property/5203580319432704/019d019d-6245-732c-8881-7ac6724e7fe3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table and comfortable seating. Step outside to the refreshing swimming pool for a perfect day.",
      "link": "false",
      "alt_text": "A spacious resident lounge here at Leilani on Greenwood featuring a central billiards table beneath modern pendant lighting, with surrounding bar-height seating, dining tables, and comfortable lounge furniture, all set within an open layout accented by large windows that bring in natural light and views of the outdoor courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(31).jpg"
    },
    {
      "id": "ec_85a879b23c755c24d70d7d94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-63f4-730e-9412-aad527fbccf4.webp",
      "image_media": {
        "alt_text": "Modern lounge area with leather sofas, a glass coffee table, and an adjacent full kitchen with stainless steel appliances.",
        "public_id": "019d019d-63f4-730e-9412-aad527fbccf4",
        "storage_key": "property/5203580319432704/019d019d-63f4-730e-9412-aad527fbccf4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax in style in our spacious lounge, featuring comfortable seating and a fully equipped kitchen, perfect for entertaining guests or enjoying a quiet evening.",
      "link": "false",
      "alt_text": "A contemporary resident lounge here at Leilani on Greenwood featuring plush seating arranged around a glass coffee table, warm neutral carpeting, and a fully equipped community kitchen with an island, bar seating, pendant lighting, and modern cabinetry, creating an inviting space for gatherings, events, and everyday relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(32).jpg"
    },
    {
      "id": "ec_c327ca648d51093babe50a7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-62cd-7099-99aa-b343fe9ce549.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island.",
        "public_id": "019d019d-62cd-7099-99aa-b343fe9ce549",
        "storage_key": "property/5203580319432704/019d019d-62cd-7099-99aa-b343fe9ce549.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "This modern kitchen features sleek dark wood cabinetry, stainless steel appliances including a microwave and refrigerator, and a large island with bar seating. The subway tile backsplash and contemporary pendant lights add a stylish touch.",
      "link": "false",
      "alt_text": "A modern community kitchen here at Leilani on Greenwood featuring an oversized island with bar seating, sleek countertops, contemporary pendant lighting, and a full appliance suite framed by dark wood cabinetry, with a tiled backsplash and bold accent wall that create a stylish space for resident gatherings and events.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(33).jpg"
    },
    {
      "id": "ec_614272fb0f10496af1e77d92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-68b5-75ec-9323-225a1ca46d74.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with white quartz countertops, dark wood cabinets, stainless steel appliances, and pendant lighting.",
        "public_id": "019d019d-68b5-75ec-9323-225a1ca46d74",
        "storage_key": "property/5203580319432704/019d019d-68b5-75ec-9323-225a1ca46d74.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish and functional apartment kitchen featuring a large island with a sink, sleek dark wood cabinetry, and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "A sleek community kitchen here at Leilani on Greenwood featuring an oversized island with an integrated sink, smooth countertops, modern pendant and track lighting, and a full appliance suite with contemporary cabinetry, opening into a connected resident lounge area that creates a functional and inviting space for gatherings and events.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(34).jpg"
    },
    {
      "id": "ec_5e4111a66ca91ce7a48e5dee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-6deb-767b-839e-1b85fcac2b4c.webp",
      "image_media": {
        "alt_text": "Entertainment room with bar, seating, and large TV.",
        "public_id": "019d019d-6deb-767b-839e-1b85fcac2b4c",
        "storage_key": "property/5203580319432704/019d019d-6deb-767b-839e-1b85fcac2b4c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy movie nights or game days in this spacious entertainment room, featuring a full-service bar, comfortable seating, and a large screen TV.",
      "link": "false",
      "alt_text": "A contemporary media lounge here at Leilani on Greenwood featuring bar-height counter seating with modern stools, a glass-top table, warm accent walls with framed artwork, and a spacious viewing area with comfortable seating and a large mounted television designed for entertaining, gatherings, and movie nights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(35).jpg"
    },
    {
      "id": "ec_3a7b6de0a68cbf5742f88faf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-718b-72ae-be98-c91ed65d4fe8.webp",
      "image_media": {
        "alt_text": "Community room with bar seating, a television, and a mini-fridge.",
        "public_id": "019d019d-718b-72ae-be98-c91ed65d4fe8",
        "storage_key": "property/5203580319432704/019d019d-718b-72ae-be98-c91ed65d4fe8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy our community room, perfect for socializing and entertainment, featuring comfortable seating and a large screen TV.",
      "link": "false",
      "alt_text": "A contemporary media lounge here at Leilani on Greenwood featuring bar-height counter seating with modern stools, a glass-top table, warm accent walls with framed artwork, and a spacious viewing area with comfortable seating and a large mounted television designed for entertaining, gatherings, and movie nights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(36).jpg"
    },
    {
      "id": "ec_a44def007dba39cbb0f4473c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-71c9-7340-8d54-098b5dba1007.webp",
      "image_media": {
        "alt_text": "Theater room with leather seating and large screen TV.",
        "public_id": "019d019d-71c9-7340-8d54-098b5dba1007",
        "storage_key": "property/5203580319432704/019d019d-71c9-7340-8d54-098b5dba1007.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy movie nights in our community's private theater room, featuring plush leather seating and a large screen for an immersive experience.",
      "link": "false",
      "alt_text": "A cozy private theater room here at Leilani on Greenwood featuring rows of plush reclining leather seats, a large wall-mounted television with built-in media console, warm wood-paneled accent walls, recessed lighting, and surround sound speakers creating a comfortable space for movie nights and group viewing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(37).jpg"
    },
    {
      "id": "ec_51951495e6b79952fcdcc16c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-74fe-760b-b336-41c9311252f8.webp",
      "image_media": {
        "alt_text": "Lounge area with sofas, unique wood coffee table, and view of outdoor patio with seating and red umbrella.",
        "public_id": "019d019d-74fe-760b-b336-41c9311252f8",
        "storage_key": "property/5203580319432704/019d019d-74fe-760b-b336-41c9311252f8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating and a large window overlooking the inviting outdoor patio space.",
      "link": "false",
      "alt_text": "A welcoming resident lounge here at Leilani on Greenwood featuring comfortable upholstered sofas and accent chairs arranged around a sculptural wood coffee table, large floor-to-ceiling windows and sliding glass doors opening to an outdoor courtyard, modern pendant lighting, neutral carpeting, and colorful abstract wall art creating a relaxed social gathering space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(38).jpg"
    },
    {
      "id": "ec_eb1ef9cbd76dbf7d40aba973",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-7d72-772c-8c91-9b68ab42be68.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d019d-7d72-772c-8c91-9b68ab42be68",
        "storage_key": "property/5203580319432704/019d019d-7d72-772c-8c91-9b68ab42be68.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a relaxing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and modern apartment buildings.",
      "link": "false",
      "alt_text": "A resort-style outdoor swimming pool here at Leilani on Greenwood featuring a long rectangular pool with clear blue water, surrounding concrete pool deck, cushioned lounge chairs arranged on both sides, red patio umbrellas providing shade, landscaped planters, and modern apartment buildings enclosing the courtyard under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(39).jpg"
    },
    {
      "id": "ec_7d3f794bb2e99b52e73c6146",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-8078-725a-98ef-6c0c7c093b71.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d019d-8078-725a-98ef-6c0c7c093b71",
        "storage_key": "property/5203580319432704/019d019d-8078-725a-98ef-6c0c7c093b71.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush greenery. Perfect for a sunny afternoon escape.",
      "link": "false",
      "alt_text": "A spacious outdoor swimming pool here at Leilani on Greenwood showcasing a rectangular pool with clear blue water, a wide concrete pool deck, multiple lounge chairs arranged along both sides, a metal handrail for pool entry, mature trees and landscaped greenery, red patio umbrellas, and surrounding modern apartment buildings under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(40).jpg"
    },
    {
      "id": "ec_aa5f379c8ed162794363c52e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-81a8-7589-80a8-46989e11fa53.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
        "public_id": "019d019d-81a8-7589-80a8-46989e11fa53",
        "storage_key": "property/5203580319432704/019d019d-81a8-7589-80a8-46989e11fa53.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the pool, complete with comfortable seating and lounge chairs.",
      "link": "false",
      "alt_text": "A resort-style pool courtyard here at Leilani on Greenwood featuring a long rectangular swimming pool, cushioned outdoor lounge seating in woven wicker frames, a large red patio umbrella providing shade, multiple chaise loungers lining the pool deck, modern apartment buildings surrounding the space, and landscaped greenery under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(41).jpg"
    },
    {
      "id": "ec_6e1ebb7e2e0623dfa8697887",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-894c-74ab-9314-3c02c4be56c5.webp",
      "image_media": {
        "alt_text": "Rooftop deck with grilling station, red lounge seating, and tables with chairs.",
        "public_id": "019d019d-894c-74ab-9314-3c02c4be56c5",
        "storage_key": "property/5203580319432704/019d019d-894c-74ab-9314-3c02c4be56c5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor living on the rooftop deck, complete with a grilling station, comfortable lounge seating, and tables for al fresco dining.",
      "link": "false",
      "alt_text": "A spacious rooftop deck here at Leilani on Greenwood featuring a wood-plank patio with bright red modern lounge seating, round café tables with chairs, an outdoor grilling station, and black metal railing, all overlooking treetops and surrounding rooftops beneath a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(42).jpg"
    },
    {
      "id": "ec_041668feeb95e322110d45b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-8d94-76cf-bd2b-f8ef9cab66ec.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, fire pit, and grills.",
        "public_id": "019d019d-8d94-76cf-bd2b-f8ef9cab66ec",
        "storage_key": "property/5203580319432704/019d019d-8d94-76cf-bd2b-f8ef9cab66ec.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community patio featuring comfortable seating, a modern fire pit, and convenient grills for resident use.",
      "link": "false",
      "alt_text": "A landscaped outdoor courtyard here at Leilani on Greenwood featuring a paved patio with modern seating, wood pergolas casting shade over lounge areas, cushioned sofas, café-style chairs and tables, built-in fire pit seating, and grilling stations, all surrounded by mature trees, privacy fencing, and contemporary apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(43).jpg"
    },
    {
      "id": "ec_5728cfe05a74c1b2b22b2fdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-8e24-718f-abfb-59a412f2ebb5.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with seating areas and umbrellas.",
        "public_id": "019d019d-8e24-718f-abfb-59a412f2ebb5",
        "storage_key": "property/5203580319432704/019d019d-8e24-718f-abfb-59a412f2ebb5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this stylish courtyard, perfect for relaxing or socializing with friends.",
      "link": "false",
      "alt_text": "A modern outdoor courtyard here at Leilani on Greenwood showcasing a spacious concrete patio with café-style tables and chairs, bright red patio umbrellas providing shade, a comfortable outdoor sofa with accent pillows, and lounge seating, set against colorful building exteriors with bold red, yellow, and neutral tones that create a vibrant, urban atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(44).jpg"
    },
    {
      "id": "ec_ee13487ac8b05da08832cc24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-8ef2-74ef-bf91-e45e25203796.webp",
      "image_media": {
        "alt_text": "Rooftop deck with lounge chairs, tables, and modern seating.",
        "public_id": "019d019d-8ef2-74ef-bf91-e45e25203796",
        "storage_key": "property/5203580319432704/019d019d-8ef2-74ef-bf91-e45e25203796.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the outdoors on the spacious rooftop deck, complete with comfortable lounge seating, tables for gathering, and stunning views.",
      "link": "false",
      "alt_text": "A sunny rooftop deck here at Leilani on Greenwood featuring expansive wood plank flooring, modern lounge chairs arranged for relaxation, bold red sculptural seating, small accent tables, and perimeter railings that frame open sky and distant views, creating an inviting outdoor gathering space designed for socializing and enjoying fresh air.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(45).jpg"
    },
    {
      "id": "ec_4ae7161af2300073ebe7aa84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019d-95cb-7373-ac1a-a01f791be5d6.webp",
      "image_media": {
        "alt_text": "Leilani on Greenwood apartment building entrance and leasing office.",
        "public_id": "019d019d-95cb-7373-ac1a-a01f791be5d6",
        "storage_key": "property/5203580319432704/019d019d-95cb-7373-ac1a-a01f791be5d6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to Leilani on Greenwood, featuring our leasing office entrance with modern architecture and lush landscaping. Experience upscale apartment living.",
      "link": "false",
      "alt_text": "A modern leasing office exterior here at Leilani on Greenwood featuring a glass entry door beneath a metal awning labeled leasing office, large storefront windows with community signage, concrete walkways with handrails, and raised planters filled with greenery that frame the entrance and create a welcoming street-level arrival.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Leilani_Favorites%20(46).jpg"
    },
    {
      "id": "ec_af3227d8ac1724e0cec0e35d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fc0da-061a-729a-9972-8f517d595d6d.webp",
      "image_media": {
        "alt_text": "Outdoor patio with fire pit and grills",
        "public_id": "019fc0da-061a-729a-9972-8f517d595d6d",
        "storage_key": "property/5203580319432704/019fc0da-061a-729a-9972-8f517d595d6d.webp",
        "width": 1344,
        "height": 890
      },
      "title": "Community",
      "description": "Enjoy the outdoor living space with a modern fire pit and grilling stations.",
      "link": "false",
      "alt_text": "A fire pit with a wooden pergola above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Fire%20Pit%20Fun.jpg"
    },
    {
      "id": "ec_4071affdc6c3048e02bb610b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fc0da-060d-761c-86b8-b79e457d64fe.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with fire pit and seating.",
        "public_id": "019fc0da-060d-761c-86b8-b79e457d64fe",
        "storage_key": "property/5203580319432704/019fc0da-060d-761c-86b8-b79e457d64fe.webp",
        "width": 953,
        "height": 506
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor lounge, featuring a modern fire pit and comfortable seating for socializing or quiet enjoyment.",
      "link": "false",
      "alt_text": "A patio with a table and chairs under a wooden pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Fire%20pit%20.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1c0eed70-21d9-4e59-be5a-9927e81fbc19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "9208 Holman Rd NW, Seattle, WA 98117",
      "poi_short_description": "Nostalgic fast food joint serving up simple burgers, fries, and shakes for lunch and dinner in the Wallingford neighborhood.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious Deluxe burgers, fries, and chocolate shakes at affordable prices. They also highlight the fast and friendly service, and classic drive-in vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7026-721b-9b18-c76931ad60f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7026-721b-9b18-c76931ad60f2",
        "storage_key": "property/5203580319432704/019d019e-7026-721b-9b18-c76931ad60f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ddir.com/",
      "poi_directions_map_url": "https://www.google.com/maps/place/Dick's+Drive-In/@47.7010091,-122.3707174,3524m/data=!3m1!1e3!4m6!3m5!1s0x5490169bc6401599:0x6aed8b5f60bf05e2!8m2!3d47.6964016!4d-122.3716869!16s%2Fg%2F1txc6r2c!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MTAxNC4wIKXMDSoASAFQAw%3D%3D",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.696481539289294",
      "poi_longitude": "-122.37178538153994",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "23",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+12067835233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b777-7690-b532-c4cb3d78a734",
        "storage_key": "property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd5TY51gUkFQRU_h3DzLnCi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_28a8e6f4-3e74-4cac-bc7d-75d6e6e453d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "FOB Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "2101 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Casual restaurant where customers can select their own sushi by the pound.",
      "poi_long_description": "Diners say this sushi restaurant offers a wide variety of fresh sushi and nigiri, with a pay-by-weight pricing model that allows customers to customize their orders. They also highlight the quick and friendly service, and the convenient location for those looking for a quick and affordable meal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-6f62-773e-8c9f-4c243b7594de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-6f62-773e-8c9f-4c243b7594de",
        "storage_key": "property/5203580319432704/019d019e-6f62-773e-8c9f-4c243b7594de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12122460682108664144",
      "poi_item_slug": "fob-sushi-bar",
      "poi_latitude": "47.6140698",
      "poi_longitude": "-122.3421031",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b777-7690-b532-c4cb3d78a734",
        "storage_key": "property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2vW1YQVkFQRUPm5SMOhO6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_000e8bfd-8b06-4194-a494-7edc00d32337",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "2621 NE 46th St, Seattle, WA 98105, USA",
      "poi_short_description": "Chain eatery known for handmade Taiwanese fare such as soup dumplings and noodles.",
      "poi_long_description": "Diners say this Chinese restaurant serves up delicious soup dumplings, spicy wontons, and a variety of other authentic dishes, including vegan options. They also highlight the friendly and professional staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-6fdf-765e-b5d7-ba242c84b414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-6fdf-765e-b5d7-ba242c84b414",
        "storage_key": "property/5203580319432704/019d019e-6fdf-765e-b5d7-ba242c84b414.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/us/locations/seattle-university-village.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=814160589347388683",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "47.6614929",
      "poi_longitude": "-122.2996132",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-525-0958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b777-7690-b532-c4cb3d78a734",
        "storage_key": "property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbLpOI8UkFQRC30sDr56TAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_eee86dc7-e8ed-4140-951d-e5aaf694589e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12801 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus breakfast options.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken sandwiches, waffle fries, and nuggets, with a variety of tasty dipping sauces. They also highlight the friendly and efficient staff, and the clean and welcoming atmosphere.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7632-73f2-af6d-65ca2855fc9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7632-73f2-af6d-65ca2855fc9d",
        "storage_key": "property/5203580319432704/019d019e-7632-73f2-af6d-65ca2855fc9d.webp",
        "width": 1136,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/aurora-ave-n-130th?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=11462368208549691034",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.72255999999999",
      "poi_longitude": "-122.34533",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-364-0841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b777-7690-b532-c4cb3d78a734",
        "storage_key": "property/5203580319432704/019d019e-b777-7690-b532-c4cb3d78a734.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z6AfAQTkFQRmr5VyyeDEp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a47ca81f-b2f5-41ca-b081-a59fbeaf9fce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Outdoor shopping center with various local retailers, a play area, and restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and restaurants, with a dog-friendly, outdoor, and upscale atmosphere. They also highlight the clean and well-maintained environment, the convenient parking garages, and the family-friendly features like a playground and water fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-76e7-755f-9aaa-7c79b86040bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-76e7-755f-9aaa-7c79b86040bd",
        "storage_key": "property/5203580319432704/019d019e-76e7-755f-9aaa-7c79b86040bd.webp",
        "width": 1280,
        "height": 764
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6616885",
      "poi_longitude": "-122.2990339",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d50b65e6ae80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d50b65e6ae80",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d50b65e6ae80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_feb835d6-d292-4b46-bb2a-ff4eb8351ba0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Northgate Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Shopping center with a variety of stores, restaurants, and a playground.",
      "poi_long_description": "Indoor shopping mall with department stores, a play area & a couple dozen eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-762f-7305-86ac-d9d4d3be5dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-762f-7305-86ac-d9d4d3be5dd5",
        "storage_key": "property/5203580319432704/019d019e-762f-7305-86ac-d9d4d3be5dd5.webp",
        "width": 1000,
        "height": 669
      },
      "poi_business_url": "https://www.simon.com/mall/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7968531460125271769",
      "poi_item_slug": "northgate-station",
      "poi_latitude": "47.70612269999999",
      "poi_longitude": "-122.3258649",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-362-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d50b65e6ae80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d50b65e6ae80",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d50b65e6ae80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn7o7cFYRkFQR2aZK1iTplW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_46df2a7f-ee2d-44d9-ab35-d2b93916fc43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4555 Roosevelt Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "Neighborhood grocery chain offering its signature items along with produce, wine, and fresh flowers.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of products, including frozen meals, cheese, fresh vegetables, and flowers, at affordable prices. They also highlight the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7c33-71ce-a8dd-da79145f057d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7c33-71ce-a8dd-da79145f057d",
        "storage_key": "property/5203580319432704/019d019e-7c33-71ce-a8dd-da79145f057d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/137/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10181451224793493704",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.66268549999999",
      "poi_longitude": "-122.3177437",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-547-6299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d11c012ae56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d11c012ae56d",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d11c012ae56d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6Rq_l8UkFQRyDDI__HHS40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4fa12945-a9a4-459f-838a-8217afc2ffaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1026 NE 64th St, Seattle, WA 98115, USA",
      "poi_short_description": "Chain grocer supplying organic foods such as vegetables and prepared dishes, plus wine.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, delicious baked goods, and a great selection of cheeses. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7c32-7651-9a76-b6d9e1a8ba2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7c32-7651-9a76-b6d9e1a8ba2a",
        "storage_key": "property/5203580319432704/019d019e-7c32-7651-9a76-b6d9e1a8ba2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/rooseveltsquare?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12345175728734872312",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6751401",
      "poi_longitude": "-122.3159059",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-985-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d11c012ae56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d11c012ae56d",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d11c012ae56d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3kY6m8UkFQR-CIE8erfUqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8455c9a4-34a1-4811-b492-f449677b0072",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Shoreline Community College",
      "poi_type": "Education",
      "poi_address": "16101 Greenwood Ave N, Shoreline, WA 98133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7d91-767d-8902-b85a2c8fc8e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7d91-767d-8902-b85a2c8fc8e7",
        "storage_key": "property/5203580319432704/019d019e-7d91-767d-8902-b85a2c8fc8e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shoreline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5663351517267791817",
      "poi_item_slug": "shoreline-community-college",
      "poi_latitude": "47.747453",
      "poi_longitude": "-122.3586266",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-546-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d9196dfa7234",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPYEIfNsQkFQRyY_qADNEmE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3f219144-61fe-4c9c-8729-e12b8c8a3bda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-7c82-724c-86ed-e61480f20969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-7c82-724c-86ed-e61480f20969",
        "storage_key": "property/5203580319432704/019d019e-7c82-724c-86ed-e61480f20969.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.65671709999999",
      "poi_longitude": "-122.3066181",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d9196dfa7234",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_064a6f86-2109-4558-b665-c8d84108c375",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8258-743b-926a-fd67cf7f09b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8258-743b-926a-fd67cf7f09b2",
        "storage_key": "property/5203580319432704/019d019e-8258-743b-926a-fd67cf7f09b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d9196dfa7234",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_887b91d6-13fb-41b4-80ae-c92fc9faa945",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8239-706e-a587-cda8302439c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8239-706e-a587-cda8302439c2",
        "storage_key": "property/5203580319432704/019d019e-8239-706e-a587-cda8302439c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d9196dfa7234",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8db813ef-41fc-4435-bd3d-2ac21f2730b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "The Quad - University of Washington",
      "poi_type": "Education",
      "poi_address": "Pierce Ln, Seattle, WA 98195, USA",
      "poi_short_description": "Scenic University of Washington park with Yoshino cherry trees surrounded by Gothic architecture.",
      "poi_long_description": "Scenic University of Washington park with Yoshino cherry trees surrounded by Gothic architecture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-826e-7719-9af9-04ffab0e9f32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-826e-7719-9af9-04ffab0e9f32",
        "storage_key": "property/5203580319432704/019d019e-826e-7719-9af9-04ffab0e9f32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.washington.edu/home/tour/lib_quad.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7224369593643053704",
      "poi_item_slug": "the-quad---university-of-washington",
      "poi_latitude": "47.65726309999999",
      "poi_longitude": "-122.3071972",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-543-9198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-b776-77b8-ae3d-d9196dfa7234",
        "storage_key": "property/5203580319432704/019d019e-b776-77b8-ae3d-d9196dfa7234.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyZAfHY0UkFQRiDI6e94dQmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6de89757-a396-4ea4-bedb-29419b26fabf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "Fans say this arena hosts exciting Kraken hockey games and concerts, and they praise the excellent acoustics and wide variety of food options. They also highlight the friendly and helpful staff, and the clean and modern facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8581-74af-9acb-86a2371b0285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8581-74af-9acb-86a2371b0285",
        "storage_key": "property/5203580319432704/019d019e-8581-74af-9acb-86a2371b0285.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.62207129999999",
      "poi_longitude": "-122.3540714",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6f78eeb2-9332-487c-9327-ef316067307a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "Variety of wildlife on display, plus a carousel, rainforest exhibit, and bug house.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animal exhibits, including gorillas, penguins, and a dinosaur exhibit, and they praise the family-friendly atmosphere and well-maintained grounds. They also highlight the reasonable prices, especially with the annual pass, and the educational value for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-87b4-751b-93b0-e652d90caff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-87b4-751b-93b0-e652d90caff7",
        "storage_key": "property/5203580319432704/019d019e-87b4-751b-93b0-e652d90caff7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_c788d09d-6bea-4621-b475-d1e941ac8e1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Chihuly Garden and Glass",
      "poi_type": "Entertainment",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "Showcasing the work of Dale Chihuly, this venue features glass sculptures, a garden, and a glasshouse.",
      "poi_long_description": "Visitors say this art museum showcases stunning glass sculptures and features a glass blowing demonstration in the garden. They also highlight the vibrant colors, unique experience, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8892-7361-bf12-2544467c2a7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8892-7361-bf12-2544467c2a7c",
        "storage_key": "property/5203580319432704/019d019e-8892-7361-bf12-2544467c2a7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chihulygardenandglass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8881620907110491783",
      "poi_item_slug": "chihuly-garden-and-glass",
      "poi_latitude": "47.6205599",
      "poi_longitude": "-122.3504476",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-753-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba90-72bb-8ccd-26a902585011",
        "storage_key": "property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTtr1kUVkFQRh-YAfijbQXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_93404952-6b10-4ef0-8729-7ba767219008",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Museum of Pop Culture",
      "poi_type": "Entertainment",
      "poi_address": "325 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_long_description": "Visitors say this museum offers a diverse collection of exhibits, including Nirvana memorabilia, horror movie props, and a sound lab with interactive instruments. They also highlight the friendly staff and engaging, well-executed exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8964-7499-a2b5-d5692072602c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8964-7499-a2b5-d5692072602c",
        "storage_key": "property/5203580319432704/019d019e-8964-7499-a2b5-d5692072602c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mopop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125666784235608082",
      "poi_item_slug": "museum-of-pop-culture",
      "poi_latitude": "47.6214824",
      "poi_longitude": "-122.3481245",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-770-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba90-72bb-8ccd-26a902585011",
        "storage_key": "property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8p6-EYVkFQREthJEc0p6dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6badfaf6-7e4a-406e-9bd9-8f665739b989",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Pacific Science Center",
      "poi_type": "Entertainment",
      "poi_address": "200 Sue Bird Ct N, Seattle, WA 98109, USA",
      "poi_short_description": "Science museum featuring a planetarium, IMAX theater, and laser shows, plus a butterfly garden.",
      "poi_long_description": "Visitors say this science museum features a butterfly exhibit, dinosaur exhibit, laser dome, planetarium, and IMAX theater. They also highlight the friendly staff, hands-on activities, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8a4a-7038-bec7-8de1e83a51ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8a4a-7038-bec7-8de1e83a51ef",
        "storage_key": "property/5203580319432704/019d019e-8a4a-7038-bec7-8de1e83a51ef.webp",
        "width": 651,
        "height": 651
      },
      "poi_business_url": "https://www.pacificsciencecenter.org/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072473183036697406",
      "poi_item_slug": "pacific-science-center",
      "poi_latitude": "47.62004",
      "poi_longitude": "-122.3515628",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-443-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba90-72bb-8ccd-26a902585011",
        "storage_key": "property/5203580319432704/019d019e-ba90-72bb-8ccd-26a902585011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxZWvUwVkFQRPuvwC7JTqZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_774edfb5-3896-46d9-9565-fb4587253a2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "507 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Chain gym offering cardio and strength training equipment, classes, a lap pool, and personal trainers.",
      "poi_long_description": "Some gym goers say this gym has a friendly and helpful staff, a wide range of machines and weights, and popular Body Pump classes.\n\nOther reviews mention the gym can be crowded and the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-8f48-76e9-b4fc-92974c80eb17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-8f48-76e9-b4fc-92974c80eb17",
        "storage_key": "property/5203580319432704/019d019e-8f48-76e9-b4fc-92974c80eb17.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/seattle-wa/northgate-fifth-ave-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5024363022030936683",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.7082989",
      "poi_longitude": "-122.3229892",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-368-2431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1rcAlcRkFQRaxrDXowfukU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_430ff48b-8c4e-4f10-b700-29b8acc46e92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13201 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment and massage chairs, plus a tanning salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9495-7017-b42f-1d9992d864ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9495-7017-b42f-1d9992d864ed",
        "storage_key": "property/5203580319432704/019d019e-9495-7017-b42f-1d9992d864ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/seattle-aurora-ave-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11165522815278832073",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.726047",
      "poi_longitude": "-122.346958",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-659-4577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2elQYTERkFQRydk20Nfn85o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c13808af-89cc-4372-bfc6-87340fa00e4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13244 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "Chain health club offering state-of-the-art facilities, pools, and group classes, plus basketball and racquetball courts.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including a dry sauna, hot tub, and a 3-lane lap pool, and the staff is friendly.\n\nOther reviews mention the gym can be crowded and some people don't follow sauna etiquette.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9554-74ee-bafb-285d25a2fb36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9554-74ee-bafb-285d25a2fb36",
        "storage_key": "property/5203580319432704/019d019e-9554-74ee-bafb-285d25a2fb36.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=326&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2707988696116944436",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.726277",
      "poi_longitude": "-122.3431823",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-973-0232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2Xd2TARkFQRNN7SH1-1lCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_652a6b93-0e9e-438c-a071-0ab93be93e6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Olympic Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 Leary Ave NW, Seattle, WA 98107, USA",
      "poi_short_description": "Local fitness center offering a variety of equipment and classes, plus pools, racquetball, and a sauna.",
      "poi_long_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9581-71bf-9b7c-c88eb40ed304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9581-71bf-9b7c-c88eb40ed304",
        "storage_key": "property/5203580319432704/019d019e-9581-71bf-9b7c-c88eb40ed304.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.olympicathleticclub.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243484350012506487",
      "poi_item_slug": "olympic-athletic-club",
      "poi_latitude": "47.6664152",
      "poi_longitude": "-122.3828324",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-944-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-6exLYVkFQRd8Fg0Qp0R4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f4b070de-f574-46fa-80ef-8a10a71af8df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Barry's Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "112 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Fitness studio offering high-intensity workouts in a dark room accompanied by music.",
      "poi_long_description": "People say this fitness center offers great cardio, strength, weights, resistance, stretching, and agility workouts with good music and positive energy. They also highlight the friendly atmosphere, clean studio, and motivational instructors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-96e1-7013-9e69-73469db2b168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-96e1-7013-9e69-73469db2b168",
        "storage_key": "property/5203580319432704/019d019e-96e1-7013-9e69-73469db2b168.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.barrys.com/studio/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874324567168923080",
      "poi_item_slug": "barrys-seattle",
      "poi_latitude": "47.6188612",
      "poi_longitude": "-122.3382048",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-687-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8epeK8VkFQRyDXkY0PwAho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0225cd3b-7f39-4fbb-a9c9-63304942cf53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Urban Nail Box - Ballard",
      "poi_type": "Health and Wellness",
      "poi_address": "1453 NW 54th St Suite B, Seattle, WA 98107, USA",
      "poi_short_description": "Nail salon with a focus on low-toxic and organic products set in a nurturing environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-999b-7059-b3c7-2361c8db614a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-999b-7059-b3c7-2361c8db614a",
        "storage_key": "property/5203580319432704/019d019e-999b-7059-b3c7-2361c8db614a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://urbannailbox.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364560216485406009",
      "poi_item_slug": "urban-nail-box---ballard",
      "poi_latitude": "47.6675924",
      "poi_longitude": "-122.3753019",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-866-4642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQwSx8kVkFQROSWKswG-l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_8b056d4e-1716-422a-9e0a-1438b5844147",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Flow Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "311 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Gym offering a variety of classes including yoga, Zumba, and cycling, plus training and open gym access.",
      "poi_long_description": "People say this gym offers fun yoga and barre classes with amazing instructors, and they appreciate the clean facilities and convenient location. They also highlight the friendly and caring staff, and the variety of classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9b11-773c-9958-8078179e2fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9b11-773c-9958-8078179e2fc4",
        "storage_key": "property/5203580319432704/019d019e-9b11-773c-9958-8078179e2fc4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://flowfitnessseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12376552079455074786",
      "poi_item_slug": "flow-fitness",
      "poi_latitude": "47.62137",
      "poi_longitude": "-122.3374609",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-621-7246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSSesTcVkFQR4rkK4IpYwqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0d785062-7fc7-4bfd-a238-19ec50dfd102",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9a2e-71e0-8d49-b288a30c7ccb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9a2e-71e0-8d49-b288a30c7ccb",
        "storage_key": "property/5203580319432704/019d019e-9a2e-71e0-8d49-b288a30c7ccb.webp",
        "width": 920,
        "height": 612
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628348",
      "poi_longitude": "-122.2820633",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba96-7782-9c4f-edb758d36ea5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba96-7782-9c4f-edb758d36ea5",
        "storage_key": "property/5203580319432704/019d019e-ba96-7782-9c4f-edb758d36ea5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4fb7f134-b4fe-4396-b29e-c11ca052ecab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "UW Medical Center - Montlake | Seattle Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1959 NE Pacific St Main Hospital, Seattle, WA 98195, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9c98-7526-a7fa-31c9168f8ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9c98-7526-a7fa-31c9168f8ee6",
        "storage_key": "property/5203580319432704/019d019e-9c98-7526-a7fa-31c9168f8ee6.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/uw-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469901287147718853",
      "poi_item_slug": "uw-medical-center---montlake--seattle-hospital",
      "poi_latitude": "47.6491689",
      "poi_longitude": "-122.3062168",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-598-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba96-7782-9c4f-edb758d36ea5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba96-7782-9c4f-edb758d36ea5",
        "storage_key": "property/5203580319432704/019d019e-ba96-7782-9c4f-edb758d36ea5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEU9wSOwUkFQRxUjYrb-PTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_65c41206-19d9-46cf-86b9-3915ca3b6100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "City park offering a playground, a picnic area, and views of the Space Needle.",
      "poi_long_description": "Visitors say this city park offers stunning views of the Seattle skyline, Space Needle, and Lake Union, especially at sunset. They also highlight the spacious grounds, perfect for picnics, kite flying, and enjoying live music, as well as the plentiful free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-9ff6-73d0-aafd-4dfdce0860a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-9ff6-73d0-aafd-4dfdce0860a5",
        "storage_key": "property/5203580319432704/019d019e-9ff6-73d0-aafd-4dfdce0860a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba9d-747e-9866-f749ff9927bd",
        "storage_key": "property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4e4a2d0e-9a03-459a-81d9-e1df25de67dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Kerry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 W Highland Dr, Seattle, WA 98119, USA",
      "poi_short_description": "City park with a view of the Seattle skyline, including the Space Needle, and Mount Rainier.",
      "poi_long_description": "Visitors say this city park offers a postcard-worthy view of the Seattle skyline, with Mount Rainier in the background. They also highlight the park's convenient location for walking, its clean and friendly atmosphere, and its popularity as a spot for taking photos and enjoying the sunset.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a008-727c-91cb-c469bc8a6487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a008-727c-91cb-c469bc8a6487",
        "storage_key": "property/5203580319432704/019d019e-a008-727c-91cb-c469bc8a6487.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/find/parks/kerry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744576093846549902",
      "poi_item_slug": "kerry-park",
      "poi_latitude": "47.6294692",
      "poi_longitude": "-122.3599224",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba9d-747e-9866-f749ff9927bd",
        "storage_key": "property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS2ELmoVkFQRjrUkJB5o9zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_43155211-984a-4dba-936b-520e2eaeedf7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "Park with beach access, fishing pier, picnic areas, and BBQ grills, plus sports courts and a playground.",
      "poi_long_description": "Visitors say this city park offers a sandy beach, volleyball courts, walking trails, and stunning views of the sunset and mountains. They also highlight the family-friendly atmosphere, ample parking, and numerous activities, such as swimming, picnicking, and bonfires.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a0c9-770d-aa4b-90fe46e4b49e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a0c9-770d-aa4b-90fe46e4b49e",
        "storage_key": "property/5203580319432704/019d019e-a0c9-770d-aa4b-90fe46e4b49e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba9d-747e-9866-f749ff9927bd",
        "storage_key": "property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a4eb1cf4-121e-49c9-9479-8290efb97f19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Seattle, WA 98199, USA",
      "poi_short_description": "Park offering trails, picnic facilities, and a lighthouse, plus scenic views.",
      "poi_long_description": "Visitors say this park offers scenic walking trails, a beautiful beach, and stunning views of the Puget Sound and Olympic Mountains. They also highlight that it's a great place for hiking, birdwatching, and enjoying nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a292-700a-a5e4-8ed98d13e56a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a292-700a-a5e4-8ed98d13e56a",
        "storage_key": "property/5203580319432704/019d019e-a292-700a-a5e4-8ed98d13e56a.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/discovery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879522751650882336",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "47.6613197",
      "poi_longitude": "-122.4171413",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba9d-747e-9866-f749ff9927bd",
        "storage_key": "property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0CO4fAVkFQRIGP6pMpCmFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9908cdd6-637b-4521-8509-ce59aadd6da0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Warren G. Magnuson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Sand Point Way NE, Seattle, WA 98115, USA",
      "poi_short_description": "City park with a playground, picnic and grilling areas, a swimming beach, and dog park.",
      "poi_long_description": "Visitors say this city park offers a spacious off-leash dog park with water access, sports fields, walking trails, and a beach for swimming. They also highlight the park's peaceful atmosphere, stunning views of Lake Washington and the Cascade Mountains, and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a5d7-751f-903e-15d50aeed783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a5d7-751f-903e-15d50aeed783",
        "storage_key": "property/5203580319432704/019d019e-a5d7-751f-903e-15d50aeed783.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/magnuson-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13794854175829797151",
      "poi_item_slug": "warren-g-magnuson-park",
      "poi_latitude": "47.6797687",
      "poi_longitude": "-122.2536022",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba9d-747e-9866-f749ff9927bd",
        "storage_key": "property/5203580319432704/019d019e-ba9d-747e-9866-f749ff9927bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSbT3aATkFQRHymm3sgqcb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b67efe5-a561-4a11-b5dc-b0cca6e1184b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this light rail station is clean, spacious, and well-lit, with ample security for those concerned about safety. They also highlight its convenient location near the University of Washington and the University District, making it a great option for students and visitors alike.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a5fa-73f2-ac1f-f38a04bde8e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a5fa-73f2-ac1f-f38a04bde8e1",
        "storage_key": "property/5203580319432704/019d019e-a5fa-73f2-ac1f-f38a04bde8e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_66464b97-73d9-482d-9662-b612ae1b32a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a746-7746-a6c2-6a3d7eeab0c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a746-7746-a6c2-6a3d7eeab0c5",
        "storage_key": "property/5203580319432704/019d019e-a746-7746-a6c2-6a3d7eeab0c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0268022b-34ab-4ea0-beeb-543cc4eac055",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Roosevelt",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-a804-775a-9578-c3cfa96de667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-a804-775a-9578-c3cfa96de667",
        "storage_key": "property/5203580319432704/019d019e-a804-775a-9578-c3cfa96de667.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/roosevelt-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282645169596799289",
      "poi_item_slug": "roosevelt",
      "poi_latitude": "47.67611000000001",
      "poi_longitude": "-122.31604",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1X3KKnAUkFQRORlACMu5T0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_fa653aca-32d7-419c-bd4d-a7ded672829a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Northgate",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98125, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-abd0-73fe-82f8-b6ef29f9b3eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-abd0-73fe-82f8-b6ef29f9b3eb",
        "storage_key": "property/5203580319432704/019d019e-abd0-73fe-82f8-b6ef29f9b3eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=16388369830807636916",
      "poi_item_slug": "northgate",
      "poi_latitude": "47.7030228",
      "poi_longitude": "-122.3283221",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80dxYFURkFQRtIsEJYgvb-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_617c65b8-812a-4bec-931d-1e84919a00b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Shoreline North/185th",
      "poi_type": "Transportation & Transit",
      "poi_address": "Shoreline, WA 98155, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-aba5-765f-9536-0f04b3e70c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-aba5-765f-9536-0f04b3e70c79",
        "storage_key": "property/5203580319432704/019d019e-aba5-765f-9536-0f04b3e70c79.webp",
        "width": 861,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1995772306030298641",
      "poi_item_slug": "shoreline-north185th",
      "poi_latitude": "47.76407",
      "poi_longitude": "-122.32289",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3rbWFkQkFQREYZ_mVZoshs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f88a10d8-a0fd-4821-80ef-bb9a4f4d3999",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Amazon re:Invent",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2121 8th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ad52-7035-a784-913d857e2d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-ad52-7035-a784-913d857e2d8f",
        "storage_key": "property/5203580319432704/019d019e-ad52-7035-a784-913d857e2d8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622250602859019695",
      "poi_item_slug": "amazon-reinvent",
      "poi_latitude": "47.6167313",
      "poi_longitude": "-122.3386481",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfQ75DIVkFQRrz3v1toYruY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_301dba7c-1d70-405e-9551-6d93efc60bec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "The Spheres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2111 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_long_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-aec4-7508-9d29-1e473835144d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-aec4-7508-9d29-1e473835144d",
        "storage_key": "property/5203580319432704/019d019e-aec4-7508-9d29-1e473835144d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattlespheres.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167585885114143500",
      "poi_item_slug": "the-spheres",
      "poi_latitude": "47.615728",
      "poi_longitude": "-122.3395104",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsX8RyksVkFQRDBMdYsrOOX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fe7df2f6-5f0f-4a10-b1a4-368878ed7bed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Doppler Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2021 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b1a0-7598-838e-74347b8b4f3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-b1a0-7598-838e-74347b8b4f3f",
        "storage_key": "property/5203580319432704/019d019e-b1a0-7598-838e-74347b8b4f3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16312442287447895450",
      "poi_item_slug": "doppler-building",
      "poi_latitude": "47.6150893",
      "poi_longitude": "-122.3383116",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16M6qUsVkFQRmm1kWtVvYeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5e5fc551-f402-41d9-ac2f-ab1774f4514e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Amazon Nitro North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b32b-72ec-8df7-0216942cdd81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-b32b-72ec-8df7-0216942cdd81",
        "storage_key": "property/5203580319432704/019d019e-b32b-72ec-8df7-0216942cdd81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577859250656015239",
      "poi_item_slug": "amazon-nitro-north",
      "poi_latitude": "47.6174162",
      "poi_longitude": "-122.3408815",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-946-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBay75mUVkFQRh3OGRe33BAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fa17cc3e-8410-4c36-8899-845a2b94e702",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "poi_name": "Amazon - Doppler",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2021 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-b312-7408-bbc3-f9d1a0379ddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019e-b312-7408-bbc3-f9d1a0379ddb",
        "storage_key": "property/5203580319432704/019d019e-b312-7408-bbc3-f9d1a0379ddb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11285464150585336235",
      "poi_item_slug": "amazon---doppler",
      "poi_latitude": "47.6150245",
      "poi_longitude": "-122.338417",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-280-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019e-ba80-72aa-b423-dbcabba9ecd0",
        "storage_key": "property/5203580319432704/019d019e-ba80-72aa-b423-dbcabba9ecd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubQpU0oVkFQRq2ELHdoFnpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_210c66e5ab5e5dc8ec285f38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1bc7eb57b9d652165e680afd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_597eff813ef8ede1ce7a482e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0955531121c9a68edfbe85bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c5f1ce30c8583f2d2dd6f97c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8275e2fc60a7dd27570e7861",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4c71ce5ed5c36a43e667e846",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a9b8fb89-1828-45d0-bd7d-a3df2f3b7942",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "rating": "5.0",
      "name": "TaLon C",
      "text": "I have lived in Leilani Apartments for 5 months now and dont have a single complaint. I feel extremely grateful to have found these apartments . I submitted maintenance once and they fixed the issue within hours. The environment here is so peaceful and clean. They have cleaners on a regular basis who clean the halls and community spaces and Ive never heard any noises from neighbors. I loved the pool in the summer and I use the community gym quite often as well, not to mention there is an LA fitness and planet fitness around the corner. All the neighbors Ive met are so nice and welcoming too!  I also order a ton of packages and never have issues here. The leasing office has been amazing as well. Ive always felt safe here they have security, I park in the garage and its great. I love that the light rail station is only 10 mins away for free park and ride too. Definitely dont hesitate to move here. Its been a pleasant experience!",
      "date": "2025-12-16",
      "title": ""
    },
    {
      "id": "custom_73fa0383-226f-4b9e-9d06-5c3bdd6bca84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "rating": "5.0",
      "name": "Veronica Real",
      "text": "My family live in this building. I personally really love that we can all come over and hang out in the community spaces/lounge. We always have battle to see who would  win at pool. I think this is our favorite place they have lived in. There has not been any instances where we have had a problem with anything that they weren’t on top off. The staff are always so sweet and kind. It’s always nice to feel seen when coming through those doors instead of being ignored like other places. Also those tanning chairs next to the pool!! Don’t get me started on the great naps I’ve taken there.\nI love this place.",
      "date": "2025-10-10",
      "title": "false"
    },
    {
      "id": "custom_f0a8a486-2181-4034-8806-741d03042339",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "rating": "5.0",
      "name": "Joey Stathas",
      "text": "I came to Leilani interested in possibly leasing an apartment. The staff there was extremely helpful and knowledgeable answering all the questions I had regarding the leasing process as well as the amenities they offer. I highly recommend stopping by on your hunt for your next apartment.",
      "date": "2025-11-14",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1cd2ca59-6af6-4271-aeff-5e2c6700e531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-0573-739a-818f-f63f646e07ef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-0573-739a-818f-f63f646e07ef",
        "storage_key": "property/5203580319432704/019fd3a2-0573-739a-818f-f63f646e07ef.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Greenwood ADA Studio, 1BA - 486 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yL5vZUVWgL4&play=1"
    },
    {
      "id": "custom_8a8ce35b-adc4-4f14-ab39-174ee53c24bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-05a5-759a-b617-3e505fabb407.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-05a5-759a-b617-3e505fabb407",
        "storage_key": "property/5203580319432704/019fd3a2-05a5-759a-b617-3e505fabb407.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Greenwood Open 1BR, 1BA - 573 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vLnGgNx9CJh&play=1"
    },
    {
      "id": "custom_e07544dc-2ce0-4860-bacb-9be40343bf9a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-0aa0-7233-a605-8129e45703d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-0aa0-7233-a605-8129e45703d7",
        "storage_key": "property/5203580319432704/019fd3a2-0aa0-7233-a605-8129e45703d7.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Studio, 1BA - 573 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cpojbkAu6H8&play=1"
    },
    {
      "id": "custom_ecaf4903-d3b7-46d0-afac-ad6212c9cf61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-0b85-75bb-999d-dc4e35bf82f4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-0b85-75bb-999d-dc4e35bf82f4",
        "storage_key": "property/5203580319432704/019fd3a2-0b85-75bb-999d-dc4e35bf82f4.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "107 Juniper Open 1BR, 1BA - 573 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6JyAHW7hkSy&play=1"
    },
    {
      "id": "custom_3733623f-2d81-4be3-b3d4-779ee0a7865a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-0fec-779f-8c75-ee4cdbdd3acf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-0fec-779f-8c75-ee4cdbdd3acf",
        "storage_key": "property/5203580319432704/019fd3a2-0fec-779f-8c75-ee4cdbdd3acf.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Greenwood Plan 3 Studio, 1BA - 486 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8cK51RYdMwU&play=1"
    },
    {
      "id": "custom_d5d43be7-e644-4bc9-be6b-d86fa70014bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-1062-70f8-ab15-3a77f459bb25.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-1062-70f8-ab15-3a77f459bb25",
        "storage_key": "property/5203580319432704/019fd3a2-1062-70f8-ab15-3a77f459bb25.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Greenwood 1BR, 1BA - 565 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kUVgvwtavfa&play=1"
    },
    {
      "id": "custom_4f03a817-b274-45ad-8940-e390e86d1ece",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-15d3-72ea-8a07-ebdda49c0614.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-15d3-72ea-8a07-ebdda49c0614",
        "storage_key": "property/5203580319432704/019fd3a2-15d3-72ea-8a07-ebdda49c0614.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "1BR, 1BA - Juniper",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CpEeQuGjofr&play=1"
    },
    {
      "id": "custom_2a5dc064-c444-4280-862e-026251e32b80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-1765-7355-aa5e-26c62616e061.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-1765-7355-aa5e-26c62616e061",
        "storage_key": "property/5203580319432704/019fd3a2-1765-7355-aa5e-26c62616e061.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Leilani - Live Work - N312",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AdJFNJUG4aX&play=1"
    },
    {
      "id": "custom_1718ac3b-2437-4fac-8fb8-ebdbe555e9cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-1ce2-77d9-bc76-a6d930024cc5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-1ce2-77d9-bc76-a6d930024cc5",
        "storage_key": "property/5203580319432704/019fd3a2-1ce2-77d9-bc76-a6d930024cc5.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Leilani 2 - 1x - 101",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ev332EWxBbE&play=1"
    },
    {
      "id": "custom_9ada3953-9f43-440f-8d0b-646c709b9b98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-1ddf-75ec-b1cf-b6292259b21f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-1ddf-75ec-b1cf-b6292259b21f",
        "storage_key": "property/5203580319432704/019fd3a2-1ddf-75ec-b1cf-b6292259b21f.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Leilani 2 - 1x - 104",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iLfWa6cq5ev&play=1"
    },
    {
      "id": "custom_1a08618b-76ae-4f54-8b7b-7f4f150d79fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-23af-72da-aa54-5e3993ca7202.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-23af-72da-aa54-5e3993ca7202",
        "storage_key": "property/5203580319432704/019fd3a2-23af-72da-aa54-5e3993ca7202.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Leilani - 1x - W406",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7j36ZskXivV&play=1"
    },
    {
      "id": "custom_849cadc6-cc90-4798-9f66-e716d805ff0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019fd3a2-2544-752d-888b-1699ceb067e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-2544-752d-888b-1699ceb067e1",
        "storage_key": "property/5203580319432704/019fd3a2-2544-752d-888b-1699ceb067e1.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Leilani - 1x - S406",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tGvQFnUCqbc&play=1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_85240e12006e66f7d35f84c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "2546209",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_7039f360198dabc3479ff009",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "yardi",
      "external_id": "2546208",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 75,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-2228-73df-bc9d-28ff7669493d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "leilani-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704"
    },
    {
      "lead_collector_id": "0198aa47-228a-72c1-81cc-13c9986815dd",
      "lead_source": "FACEBOOK_ADS",
      "name": "leilani-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704"
    },
    {
      "lead_collector_id": "0198aa47-22f2-70cf-8dbb-73f4b555cd73",
      "lead_source": "LANDING_PAGE",
      "name": "leilani-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "rooftop-terrace-apartments-greenwood-seattle",
      "search_query": "apartments with rooftop terrace in Greenwood Seattle",
      "category": "Amenity",
      "h1_title": "Rooftop Terrace Apartments in Greenwood",
      "h2_subtitle": "Discover our apartments with rooftop terrace in Greenwood Seattle. The perfect spot to unwind and enjoy panoramic views in your new home.",
      "page_copy": "Welcome to Leilani Apartment Homes, where you can experience upscale living in the heart of Greenwood, Seattle. Our apartments boast a stunning rooftop terrace, providing residents with an unparalleled view of the city. It's the ideal place for relaxation and socializing, nestled in a vibrant community.\n\nIn addition to the stunning rooftop terrace, Leilani Apartment Homes offers a variety of luxurious amenities, including a serene infinity pool and a state-of-the-art movie theater. With modern floor plans and eco-friendly features, these apartments are the perfect blend of style and sustainability. Come visit us today to discover more about our distinguished living spaces that highlight the charm of Greenwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Apartments in Greenwood Seattle",
      "seo_description": "Enjoy panoramic views from our rooftop terrace apartments in Greenwood, Seattle. Discover upscale living at Leilani Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "infinity-pool-apartments-seattle",
      "search_query": "Seattle apartments with infinity pool",
      "category": "Amenity",
      "h1_title": "Seattle Apartments with Infinity Pool",
      "h2_subtitle": "Explore Seattle apartments with infinity pool at Leilani. Enjoy serene luxury and upscale living in Greenwood.",
      "page_copy": "Dive into luxury at Leilani Apartment Homes, where our infinity pool offers a serene escape right in the heart of Seattle. Nestled in the Greenwood neighborhood, these apartments provide a perfect blend of upscale living and community charm. Our infinity pool is not just a premium amenity; it's a tranquil retreat for relaxation and enjoyment.\n\nBeyond the pool, residents can indulge in a host of top-notch amenities such as a modern movie theater and a panoramic rooftop terrace. Experience stylish floor plans and energy-efficient features that make Leilani Apartment Homes a top choice among Seattle apartments. See firsthand what makes our community the ideal choice for those seeking both comfort and luxury with an impressive infinity pool as a centerpiece.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle Apartments with Infinity Pool",
      "seo_description": "Discover luxury living with an infinity pool at Seattle's Leilani Apartment Homes. Explore our Greenwood location today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-seattle-wa",
      "search_query": "luxury apartments with fitness center Seattle WA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Discover luxury apartments with fitness center in Seattle, WA. Leilani offers premier amenities in Greenwood.",
      "page_copy": "Welcome to Leilani Apartment Homes, the epitome of luxury living in Seattle, WA. Our apartments are designed with your wellness and lifestyle in mind, featuring an exceptional fitness center that caters to all your workout needs. Located in the vibrant Greenwood neighborhood, Leilani provides residents with more than just a place to live, but a community to thrive in.\n\nThe fitness center is just the start of the premier amenities that await you. Picture yourself unwinding at our stunning infinity pool or entertaining in our spacious gameroom. Leilani Apartment Homes offers a distinctive living experience with stylish floor plans and eco-friendly features. Come and explore the impeccable attention to detail and luxurious amenities that make our community stand out in Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center",
      "seo_description": "Experience the best of Seattle living with luxury apartments featuring a state-of-the-art fitness center at Leilani in Greenwood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "seattle-apartments-with-movie-theatre",
      "search_query": "Seattle apartments with movie theatre",
      "category": "Amenity",
      "h1_title": "Seattle Apartments with Movie Theatre",
      "h2_subtitle": "Explore our Seattle apartments with movie theatre. Enjoy cinematic experiences at Leilani's private theater in Greenwood.",
      "page_copy": "Experience the cinematic adventure at Leilani Apartment Homes, where our on-site movie theater offers an exclusive entertainment experience right in the heart of Seattle. Nestled in the vibrant Greenwood neighborhood, our apartments provide a blend of convenience and luxury that you won't find elsewhere.\n\nOur private movie theater is just one of the many premium amenities offered. Complement your lifestyle with our serene infinity pool, spacious gameroom, and energetic fitness center. At Leilani Apartment Homes, you don’t just watch movies—you immerse yourself in them. Discover how our stylish living spaces and eco-friendly features combine to create a community that feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle Apartments with Movie Theatre",
      "seo_description": "Enjoy movie nights at Leilani's exclusive theater. Discover luxury Seattle apartments in Greenwood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "eco-friendly-apartments-recycling-seattle",
      "search_query": "eco-friendly apartments with recycling Seattle",
      "category": "Amenity",
      "h1_title": "Eco-Friendly Apartments with Recycling",
      "h2_subtitle": "Live in eco-friendly apartments with recycling in Seattle. Leilani combines sustainability and comfort in Greenwood.",
      "page_copy": "At Leilani Apartment Homes, sustainability is at the forefront of our community values. Our eco-friendly apartments provide residents with convenient recycling options, making it easy to live sustainably in Seattle. Located in the lively Greenwood neighborhood, Leilani is committed to creating a positive environmental impact.\n\nBeyond recycling, Leilani offers various eco-friendly features that enhance the quality of living. Residents enjoy amenities like solar-powered energy-efficient lighting and water-saving technologies. Coupled with our serene infinity pool, gameroom, and private movie theater, Leilani provides an exquisite living experience that balances luxury and sustainability. Experience the perfect blend of modern eco-friendly living in Seattle at our apartment community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Eco-Friendly Apartments with Recycling",
      "seo_description": "Discover eco-friendly living with recycling amenities at Leilani. Located in Greenwood, Seattle, our apartments offer sustainable and luxurious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-greenwood-seattle",
      "search_query": "one bedroom apartments greenwood seattle",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Greenwood",
      "h2_subtitle": "Find one bedroom apartments in Greenwood, Seattle at Leilani. Enjoy spacious living and luxurious amenities in our vibrant community.",
      "page_copy": "Discover the perfect balance of comfort and style at Leilani Apartment Homes, offering exquisite one bedroom apartments in the heart of Greenwood, Seattle. Our thoughtfully designed floor plans cater to your lifestyle needs, showcasing modern finishes and energy-efficient features that set the standard for luxurious living.\n\nSituated in the upbeat neighborhood of Greenwood, Leilani provides more than just a place to live. With access to stellar amenities like a serene infinity pool, gameroom, and a private movie theater, residents enjoy a well-rounded living experience. Our charming one-bedroom apartments offer a unique blend of elegance and functionality, making them a welcoming retreat from the bustling city life of Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Greenwood",
      "seo_description": "Explore one bedroom apartments in Greenwood, Seattle at Leilani. Enjoy luxe amenities and perfect floor plans in a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "studio-apartments-near-98133",
      "search_query": "studio apartments near 98133",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near 98133",
      "h2_subtitle": "Find studio apartments near 98133 at Leilani. Experience modern comfort and amenities in Seattle's Greenwood neighborhood.",
      "page_copy": "Leilani Apartment Homes presents stylish studio apartments near the 98133 area, perfect for those seeking a contemporary living experience in Seattle. Located in the vibrant Greenwood neighborhood, our studios are designed with both convenience and sophistication in mind, featuring energy-efficient appliances and smart space usage.\n\nEnjoy an enhanced living experience with access to exclusive amenities like our private movie theater, infinity pool, and gameroom. With a strong sense of community and close proximity to Seattle's finest attractions, Leilani's studio apartments offer a delightful combination of urban living and neighborhood charm. Discover the perfect studio to call home just around the corner from everything Seattle has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near 98133",
      "seo_description": "Discover studio apartments near 98133 at Leilani. Enjoy luxury amenities and modern living in Seattle's Greenwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5203580319432704",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-king-county-wa",
      "search_query": "two bedroom apartments in king county wa",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in King County",
      "h2_subtitle": "Explore two bedroom apartments in King County, WA at Leilani. Enjoy spacious living and luxurious amenities in Seattle's Greenwood area.",
      "page_copy": "Leilani Apartment Homes offers exceptional two bedroom apartments in King County, WA, blending comfort with modern design. Our spacious floor plans accommodate a range of lifestyles, ensuring that each tenant enjoys a well-appointed living space in Seattle's thriving Greenwood neighborhood.\n\nOur community stands out with its exclusive amenities, including a panoramic rooftop terrace, a serene infinity pool, and a state-of-the-art movie theater, all designed to enhance your living experience. Leilani's two bedroom suites provide ample space, modern finishes, and energy-efficient touches, creating an ideal home setup. Discover the perfect combination of style and functionality in our vibrant Seattle community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Leilani on Greenwood.",
        "public_id": "019d019e-61a6-735d-b74c-cc0e67c384dd",
        "storage_key": "property/5203580319432704/019d019e-61a6-735d-b74c-cc0e67c384dd.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in King County",
      "seo_description": "Find spacious two bedroom apartments in King County, WA at Leilani. Enjoy luxury amenities in Seattle's vibrant Greenwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4785"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445313"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095341"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TM3XJQ29"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3e5a7003-c4dd-4de3-a938-815039bd611f/app.js?property=3e5a7003-c4dd-4de3-a938-815039bd611f&propertyName=Leilani+Apartment+Homes&channelUuid=c248f2c1-8dac-11ec-afb4-42010aa8d42b&buttonbgcolor=b33e25\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47677586962"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVCOS9jeTlHTHNibmgrNnlmMEhVYlE9PSIsInZhbHVlIjoiZnpiS3FNd3hySG95SmtIUXRXZE9iUT09IiwibWFjIjoiODZjOWI1ZDZlNzA0MmExYmNhMjIxMzM1ZjZhZDE0MzkyZWVlMDEwZmFmODhmNzkwZmM2NGQ5YmJkNzZjZDI2MiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4785",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445313",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095341",
  "custom_google_gtm_id": "GTM-TM3XJQ29",
  "custom_rollout_phase": "Phase 6",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3e5a7003-c4dd-4de3-a938-815039bd611f/app.js?property=3e5a7003-c4dd-4de3-a938-815039bd611f&propertyName=Leilani+Apartment+Homes&channelUuid=c248f2c1-8dac-11ec-afb4-42010aa8d42b&buttonbgcolor=b33e25\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47677586962",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVCOS9jeTlHTHNibmgrNnlmMEhVYlE9PSIsInZhbHVlIjoiZnpiS3FNd3hySG95SmtIUXRXZE9iUT09IiwibWFjIjoiODZjOWI1ZDZlNzA0MmExYmNhMjIxMzM1ZjZhZDE0MzkyZWVlMDEwZmFmODhmNzkwZmM2NGQ5YmJkNzZjZDI2MiJ9",
  "custom_audioeye_site_id": "13682a83-e329-4eef-bd8f-bbd917f1d419",
  "custom_audioeye_site_hash": "1076ad86628c61a1d5798ee68f5f5841"
};

export const generatedAt = '2026-11-03T23:42:59.446Z';
